var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.268,
    height: 136.94,
    viewBox: "0 0 200.268 136.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5031661",
    "data-name": 5031661,
    transform: "translate(-62.2 -34.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(62.2 34.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(14.854 119.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M263.346,408.3H134.53c-16.038,1.825-25.93,4.354-25.93,7.139,0,5.6,40.431,10.148,90.338,10.148s90.338-4.546,90.338-10.148C289.276,412.654,279.384,410.157,263.346,408.3Z",
    transform: "translate(-108.6 -408.3)",
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(6.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M273.064,154.4c.768-2.433,0-5.474-1.281-7.875-1.665-3.137-4.1-6.05-4.514-9.6-.768-6.723,5.986-12.421,5.73-19.207-.32-8.067-10.34-13.285-10.372-21.352-.032-7.555,8.867-13.413,7.619-20.872-1.12-6.691-9.187-9.123-14.085-13.765-4.8-4.546-5.666-12.421-10.756-16.678-4.033-3.393-8.483-5.826-13.861-5.954-3.521-.1-6.466.992-9.828,1.857-8.611,2.177-17.415-3.809-25.61-5.506a46.616,46.616,0,0,0-19.623.256c-4.61,1.056-9.027,2.689-13.605,3.905a26.163,26.163,0,0,1-13.061.224c-10.916-2.4-27.69,4.45-35.373,11.012-8.515,7.267-8.9,16.678-12.933,27.21-3.905,10.18-4.9,21.384-9.348,31.34-2.465,5.474-5.922,10.468-8.163,16.07a39.942,39.942,0,0,0-.128,28.939Z",
    transform: "translate(-81.224 -34.524)",
    fill: "#c7d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(0 6.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(16.87 2.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(39.396 72.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M329.468,338.47a1.4,1.4,0,0,0,1.313-1.921c-1.088-2.657-4.13-4.482-7.011-5.346-5.09-1.537-10.532-1.5-15.846-1.729s-10.788-.8-15.494-3.361a16.075,16.075,0,0,1-4.13-3.2V290.9h-7.747v32.012a17.247,17.247,0,0,1-4.129,3.2c-4.674,2.561-10.148,3.137-15.494,3.361-5.314.224-10.724.224-15.846,1.729-2.913.864-5.954,2.689-7.011,5.346a1.4,1.4,0,0,0,1.313,1.921H241.5l-.128-.032a2.52,2.52,0,0,1,1.569-1.921,8.58,8.58,0,0,1,2.529-1.024c4.258-.384,73.66-.384,77.917,0a8.245,8.245,0,0,1,2.529,1.024,2.572,2.572,0,0,1,1.569,1.921l-.128.032Z",
    transform: "translate(-237.967 -290.9)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(83.904 94.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M379.241,371.233h-.032A2.213,2.213,0,0,1,377,369.024v-9.316a2.213,2.213,0,0,1,2.209-2.209h.032a2.213,2.213,0,0,1,2.209,2.209v9.316A2.234,2.234,0,0,1,379.241,371.233Z",
    transform: "translate(-377 -357.5)",
    fill: "#352f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M281.555,167.55a553.692,553.692,0,0,0-163.9,0,2.393,2.393,0,0,1-2.753-2.369V66.008a2.393,2.393,0,0,1,2.753-2.369,553.691,553.691,0,0,0,163.9,0,2.393,2.393,0,0,1,2.753,2.369V165.15A2.4,2.4,0,0,1,281.555,167.55Z",
    transform: "translate(-114.9 -63.611)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(1.665 2.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M283.3,172.17a534.411,534.411,0,0,0-163.2,0V71.3a534.411,534.411,0,0,0,163.2,0Z",
    transform: "translate(-120.1 -71.3)",
    fill: "#a4b0bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(120.173 6.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 38.575,
    height: 22.729,
    fill: "#92a1ad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(3.105 1.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M124.6,68.4V169.27c4.322-.672,8.643-1.281,13-1.825l25.29-94.532Q143.679,71.377,124.6,68.4Z",
    transform: "translate(-124.6 -68.4)",
    fill: "#c7d3dd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(3.073 22.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M151.966,184.748a29.917,29.917,0,0,1-13.413-2.049c-6.242-2.721-9.924-8.2-14.053-13.093v43.376a534.413,534.413,0,0,1,163.2,0V132.6c-39.215,16.742-78.27,31.948-118.221,47.378C163.651,182.347,158.177,184.4,151.966,184.748Z",
    transform: "translate(-124.5 -132.6)",
    fill: "#92a1ad"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(50.035 7.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 68.506,
    height: 68.25,
    fill: "#708491"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(2.913 21.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 45.745,
    height: 37.518,
    fill: "#92a1ad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(120.333 35.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 45.937,
    height: 39.215,
    fill: "#708491"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(139.541 34.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 60.727,
    height: 40.111,
    fill: "#352f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(3.649 4.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(1.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M522.647,178.6a6.947,6.947,0,1,0,6.947,6.947A6.94,6.94,0,0,0,522.647,178.6Zm0,11.172a4.194,4.194,0,1,1,4.194-4.194A4.187,4.187,0,0,1,522.647,189.772Z",
    transform: "translate(-515.7 -178.6)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(0 7.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M522.647,204.8a4.21,4.21,0,0,1-4.194-4.1H515.7a6.948,6.948,0,0,0,13.893,0H526.84A4.168,4.168,0,0,1,522.647,204.8Z",
    transform: "translate(-515.7 -200.7)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(9.155 0.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M545.484,181.4l-1.185,2.465a4.194,4.194,0,0,1,2.017,3.585v.128h2.753v-.128A6.912,6.912,0,0,0,545.484,181.4Z",
    transform: "translate(-544.3 -181.4)",
    fill: "#2070b4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(16.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M574.047,178.6a6.947,6.947,0,1,0,6.947,6.947A6.94,6.94,0,0,0,574.047,178.6Zm0,11.172a4.194,4.194,0,1,1,4.194-4.194A4.187,4.187,0,0,1,574.047,189.772Z",
    transform: "translate(-567.1 -178.6)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(3.169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M580.777,181.353a4.2,4.2,0,0,1,3.105,1.377l2.017-1.857a6.913,6.913,0,0,0-5.154-2.273A7.12,7.12,0,0,0,577,179.688l1.7,2.177A4.754,4.754,0,0,1,580.777,181.353Z",
    transform: "translate(-577 -178.6)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(10.084 2.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M602.409,190.118a7.019,7.019,0,0,0-1.793-4.418l-2.017,1.857a4.238,4.238,0,0,1,1.088,2.561Z",
    transform: "translate(-598.6 -185.7)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(0.032 1.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M572.1,184.177,570.4,182a6.952,6.952,0,0,0-3.2,5.6v.256a7.01,7.01,0,0,0,1.825,4.706l2.017-1.857a4.129,4.129,0,0,1-1.12-2.849V187.6A4.179,4.179,0,0,1,572.1,184.177Z",
    transform: "translate(-567.2 -182)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(10.02 6.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M602.305,199.756V199.5h-2.753v.256a4.177,4.177,0,0,1-1.152,2.881l1.7,2.177A6.934,6.934,0,0,0,602.305,199.756Z",
    transform: "translate(-598.4 -199.5)",
    fill: "#2070b4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(32.908 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M625.447,178.6a6.947,6.947,0,1,0,6.947,6.947A6.94,6.94,0,0,0,625.447,178.6Zm0,11.172a4.194,4.194,0,1,1,4.194-4.194A4.187,4.187,0,0,1,625.447,189.772Z",
    transform: "translate(-618.5 -178.6)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(42.096 1.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M649.185,189.354a4.238,4.238,0,0,1-1.985,3.585l1.921,2.017a6.913,6.913,0,0,0,2.817-5.6,7.03,7.03,0,0,0-2.273-5.154l-1.985,1.921A4.156,4.156,0,0,1,649.185,189.354Z",
    transform: "translate(-647.2 -184.2)",
    fill: "#7d95c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(0 26.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 7.779,
    height: 1.152,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(0 2.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 4.002,
    height: 0.48,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(4.674 2.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 2.561,
    height: 0.48,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(1.377 3.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M518.218,273.7v.32h-.256v-.32H513.8v.48h6.178v-.48Z",
    transform: "translate(-513.8 -273.7)",
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(0 3.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 1.056,
    height: 0.48,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(7.811 3.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 0.992,
    height: 0.48,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(0 5.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 8.131,
    height: 0.48,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(0 6.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 5.922,
    height: 0.48,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(6.338 6.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 2.465,
    height: 0.48,
    fill: "#a4b0bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(6.338 16.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 4.866,
    height: 1.152,
    fill: "#92a1ad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(0 2.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 4.898,
    height: 0.32,
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(0 3.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 4.898,
    height: 0.32,
    fill: "#ffd255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    transform: "translate(16.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 4.866,
    height: 1.152,
    fill: "#92a1ad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(0 2.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 4.898,
    height: 0.32,
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(0 3.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 4.898,
    height: 0.32,
    fill: "#ffd255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(33.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 4.866,
    height: 1.152,
    fill: "#92a1ad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0 2.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 4.898,
    height: 0.32,
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(0 3.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 4.898,
    height: 0.32,
    fill: "#ffd255"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(68.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 66.105,
    height: 74.012,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    transform: "translate(5.314 2.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(6.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 16.838,
    height: 1.921,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(41.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 7.395,
    height: 1.921,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(41.36 4.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 7.395,
    height: 0.64,
    fill: "#e8e9eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(0 39.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M296.9,186.7a4.9,4.9,0,1,0,4.9,4.9A4.9,4.9,0,0,0,296.9,186.7Zm0,7.875a2.977,2.977,0,1,1,2.977-2.977A2.971,2.971,0,0,1,296.9,194.575Z",
    transform: "translate(-292 -186.7)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(2.945 2.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M303.153,195.9a1.953,1.953,0,1,0,1.953,1.953A1.96,1.96,0,0,0,303.153,195.9Zm0,3.681a1.729,1.729,0,1,1,1.729-1.729A1.721,1.721,0,0,1,303.153,199.581Z",
    transform: "translate(-301.2 -195.9)",
    fill: "#ffd255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(10.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M330.8,186.7a4.9,4.9,0,1,0,4.9,4.9A4.9,4.9,0,0,0,330.8,186.7Zm0,7.875a2.977,2.977,0,1,1,2.977-2.977A2.972,2.972,0,0,1,330.8,194.575Z",
    transform: "translate(-325.9 -186.7)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(2.945 2.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M337.053,195.9a1.953,1.953,0,1,0,1.953,1.953A1.961,1.961,0,0,0,337.053,195.9Zm0,3.681a1.729,1.729,0,1,1,1.729-1.729A1.721,1.721,0,0,1,337.053,199.581Z",
    transform: "translate(-335.1 -195.9)",
    fill: "#ffd255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(1.409 44.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M296.528,217.758l-.128-.288,16.742-6.819,3.649,1.6,4.482-6.466,3.009,1.889L327.548,203l.256.192-3.425,4.93-3.009-1.889-4.482,6.434L313.142,211Z",
    transform: "translate(-296.4 -203)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(5.154 4.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(0 6.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 2.945,
    height: 11.748,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(4.738 8.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 2.945,
    height: 9.924,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106",
    transform: "translate(9.508 6.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 2.945,
    height: 12.037,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    transform: "translate(14.245 9.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 2.945,
    height: 8.707,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(19.015 1.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 2.945,
    height: 16.902,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(23.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 2.945,
    height: 18.535,
    fill: "#7d95c9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210",
    transform: "translate(2.209 6.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(5.474 1.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(5.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(11.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(16.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(22.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(27.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    transform: "translate(33.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(38.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(44.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 3.809,
    height: 29.099,
    fill: "#e8e9eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    transform: "translate(0.512 1.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    transform: "translate(0.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(6.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(11.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141",
    transform: "translate(17.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(23.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(28.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    transform: "translate(34.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(39.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(45.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 0.48,
    height: 26.954,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    transform: "translate(0 13.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 1.761,
    height: 13.445,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(5.602 13.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 1.761,
    height: 13.445,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(11.204 17.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 1.761,
    height: 9.091,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(16.806 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 1.761,
    height: 18.151,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(16.806 8.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 1.761,
    height: 3.809,
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(22.408 6.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_738",
    "data-name": "Rectangle 738",
    width: 1.761,
    height: 20.968,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(28.011 13.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_739",
    "data-name": "Rectangle 739",
    width: 1.761,
    height: 13.445,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    transform: "translate(33.613 8.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_740",
    "data-name": "Rectangle 740",
    width: 1.761,
    height: 18.951,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(33.613 8.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_741",
    "data-name": "Rectangle 741",
    width: 1.761,
    height: 1.28,
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(39.215 10.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_742",
    "data-name": "Rectangle 742",
    width: 1.761,
    height: 16.87,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(44.817 13.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 1.761,
    height: 13.445,
    fill: "#faa701"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(0 3.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(0 25.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(0 21.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_745",
    "data-name": "Rectangle 745",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(0 17.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_746",
    "data-name": "Rectangle 746",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(0 12.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(0 8.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_748",
    "data-name": "Rectangle 748",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(0 4.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_749",
    "data-name": "Rectangle 749",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 3.585,
    height: 1.056,
    fill: "#e8e9eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209",
    transform: "translate(5.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(5.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_752",
    "data-name": "Rectangle 752",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(11.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    transform: "translate(16.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(22.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(27.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(33.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    transform: "translate(38.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(44.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 3.809,
    height: 0.416,
    fill: "#a4b0bc"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(0 21.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 62.328,
    height: 37.518,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(3.073 3.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(39.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(0.032 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 9.316,
    cy: 9.316,
    r: 9.316,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(2.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M211.127,133.6a9.263,9.263,0,0,0-6.627,2.817l6.21,6.659,4.354-8.611A9.452,9.452,0,0,0,211.127,133.6Z",
    transform: "translate(-204.5 -133.6)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(8.867 0.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M232.383,140.013a9.48,9.48,0,0,0-4.13-3.713l-4.354,8.611.1.1Z",
    transform: "translate(-223.9 -136.3)",
    fill: "#352f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222",
    transform: "translate(0 2.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M198.857,142.4a9.3,9.3,0,0,0-2.657,6.562,9.155,9.155,0,0,0,1.313,4.738l7.427-4.45.1-.224Z",
    transform: "translate(-196.2 -142.4)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(8.771 9.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M223.7,163.2l-.1.224.192-.128Z",
    transform: "translate(-223.6 -163.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226",
    transform: "translate(4.834 9.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M221.832,170.383l-6.4-6.883-.192.128-3.937,7.811a9.513,9.513,0,0,0,4.546,1.184A9.387,9.387,0,0,0,221.832,170.383Z",
    transform: "translate(-211.3 -163.5)",
    fill: "#352f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(1.345 9.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M200.4,168.25a9.259,9.259,0,0,0,3.489,3.361l3.938-7.811Z",
    transform: "translate(-200.4 -163.8)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(8.963 4.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M232.587,147.9l-8.387,4.994,6.4,6.883a9.388,9.388,0,0,0,3.3-7.139A9.156,9.156,0,0,0,232.587,147.9Z",
    transform: "translate(-224.2 -147.9)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(2.849 2.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 6.498,
    cy: 6.498,
    r: 6.498,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(3.713 3.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M213.434,156.468a5.634,5.634,0,1,1,5.634-5.634A5.642,5.642,0,0,1,213.434,156.468Zm0-10.98a5.314,5.314,0,1,0,5.314,5.314A5.321,5.321,0,0,0,213.434,145.488Z",
    transform: "translate(-207.8 -145.2)",
    fill: "#faa701"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258",
    transform: "translate(48.946 20.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 2.785,
    height: 0.64,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(0 1.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 4.098,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(4.642 1.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 2.017,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(6.819 1.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 1.28,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(0 3.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 1.953,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247",
    transform: "translate(2.497 3.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 5.026,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(5.826 5.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 2.305,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251",
    transform: "translate(0 5.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 5.602,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253",
    transform: "translate(0 6.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 3.521,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(4.066 6.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 1.505,
    height: 0.64,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257",
    transform: "translate(5.826 6.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 0.864,
    height: 0.64,
    fill: "#a4b0bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    "data-name": "Group 1271",
    transform: "translate(4.098 26.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 7.107,
    height: 0.448,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262",
    transform: "translate(0 1.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 8.547,
    height: 0.448,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(3.265 2.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 5.282,
    height: 0.448,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266",
    transform: "translate(0 2.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 2.497,
    height: 0.448,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268",
    transform: "translate(0 3.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 8.547,
    height: 0.448,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270",
    transform: "translate(0 4.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 8.547,
    height: 0.448,
    fill: "#a4b0bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(0 0.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(0.032 1.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(3.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 0.32,
    height: 20.872,
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(5.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 0.32,
    height: 20.872,
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(11.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 0.32,
    height: 20.872,
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(17.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 0.32,
    height: 20.872,
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(23.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 0.32,
    height: 20.872,
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283",
    transform: "translate(29.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 0.32,
    height: 20.872,
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    transform: "translate(3.105 8.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 1.921,
    height: 12.581,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288",
    transform: "translate(9.091 12.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 1.921,
    height: 8.259,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290",
    transform: "translate(14.982 8.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 1.921,
    height: 11.876,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    transform: "translate(20.904 4.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 1.921,
    height: 16.422,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    transform: "translate(26.858 11.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 1.921,
    height: 9.476,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(0 21.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 34.893,
    height: 0.256,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298",
    transform: "translate(31.692 1.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M175,147.221l-2.049-3.521-2.049,3.521h1.088v16.326h1.921V147.221Z",
    transform: "translate(-170.9 -143.7)",
    fill: "#ffd255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(0 20.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M74.329,201.956a.253.253,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.252.252,0,0,1,.256-.256h2.017c.16.032.256.128.256.256Z",
    transform: "translate(-71.8 -201.7)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303",
    transform: "translate(0 17.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M74.329,191.156a.253.253,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.253.253,0,0,1,.256-.256h2.017a.236.236,0,0,1,.256.256Z",
    transform: "translate(-71.8 -190.9)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305",
    transform: "translate(0 13.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M74.329,180.256a.252.252,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.252.252,0,0,1,.256-.256h2.017a.252.252,0,0,1,.256.256Z",
    transform: "translate(-71.8 -180)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(0 10.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M74.329,169.356a.253.253,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.252.252,0,0,1,.256-.256h2.017c.16.032.256.128.256.256Z",
    transform: "translate(-71.8 -169.1)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(0 6.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M74.329,158.556a.253.253,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.252.252,0,0,1,.256-.256h2.017a.236.236,0,0,1,.256.256Z",
    transform: "translate(-71.8 -158.3)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(0 3.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M74.329,147.656a.252.252,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.252.252,0,0,1,.256-.256h2.017a.253.253,0,0,1,.256.256Z",
    transform: "translate(-71.8 -147.4)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M74.329,136.756a.253.253,0,0,1-.256.256H72.056a.252.252,0,0,1-.256-.256h0a.252.252,0,0,1,.256-.256h2.017c.16.032.256.128.256.256Z",
    transform: "translate(-71.8 -136.5)",
    fill: "#e8e9eb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380",
    transform: "translate(139.541 4.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 38.959,
    height: 25.738,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(3.745 1.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350",
    transform: "translate(0 5.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(0 5.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 3.361,
    height: 9.412,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    transform: "translate(4.226 8.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 3.361,
    height: 6.562,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(8.451 1.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 3.361,
    height: 13.125,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(12.645 5.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 3.361,
    height: 9.412,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(16.87 1.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 3.361,
    height: 13.125,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(21.096 2.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 3.361,
    height: 12.069,
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(25.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 3.361,
    height: 14.694,
    fill: "#7d95c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349",
    transform: "translate(0 5.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(0 8.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 3.361,
    height: 0.928,
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(4.226 5.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 3.361,
    height: 3.777,
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(8.451 7.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 3.361,
    height: 1.889,
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(12.645 5.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 3.361,
    height: 3.777,
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(16.87 3.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 3.361,
    height: 6.05,
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(21.096 5.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 3.361,
    height: 3.777,
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    transform: "translate(25.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 3.361,
    height: 9.412,
    fill: "#2070b4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    transform: "translate(27.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 5.282,
    height: 0.768,
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    transform: "translate(0 1.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 2.721,
    height: 0.32,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(3.169 1.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 1.729,
    height: 0.32,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(0.928 2.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M601.509,79.7v.192h-.192V79.7H598.5v.32h4.194V79.7Z",
    transform: "translate(-598.5 -79.7)",
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360",
    transform: "translate(0 2.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 0.704,
    height: 0.32,
    fill: "#a4b0bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(5.282 2.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 0.672,
    height: 0.32,
    fill: "#a4b0bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    transform: "translate(0.384 4.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M513.369,85.84H511.32a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.344.344,0,0,1,513.369,85.84Z",
    transform: "translate(-511 -85.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    transform: "translate(4.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M526.369,85.84H524.32a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.3.3,0,0,1,526.369,85.84Z",
    transform: "translate(-524 -85.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    transform: "translate(8.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M539.569,85.84H537.52a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.321.321,0,0,1,539.569,85.84Z",
    transform: "translate(-537.2 -85.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    transform: "translate(12.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M552.769,85.84H550.72a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.344.344,0,0,1,552.769,85.84Z",
    transform: "translate(-550.4 -85.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373",
    transform: "translate(16.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M565.869,85.84H563.82a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.3.3,0,0,1,565.869,85.84Z",
    transform: "translate(-563.5 -85.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(21.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M579.069,85.84H577.02a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.321.321,0,0,1,579.069,85.84Z",
    transform: "translate(-576.7 -85.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377",
    transform: "translate(25.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M591.969,85.84H589.92a.321.321,0,0,1-.32-.32h0a.321.321,0,0,1,.32-.32h2.049a.321.321,0,0,1,.32.32h0A.3.3,0,0,1,591.969,85.84Z",
    transform: "translate(-589.6 -85.2)",
    fill: "#faa701"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544",
    transform: "translate(25.5 54.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1541",
    "data-name": "Group 1541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1540",
    "data-name": "Group 1540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417",
    transform: "translate(5.102 12.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(2.368 1.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M166.379,260.012c.128.352.032.736.224,1.056a.986.986,0,0,0,.8.448,3,3,0,0,0,.928-.192,17.586,17.586,0,0,0,1.633-.672,2.63,2.63,0,0,0,1.024-.736,2.656,2.656,0,0,0,.32-1.312,39.255,39.255,0,0,1,.9-6.082,3.979,3.979,0,0,0,.192-1.5,1.633,1.633,0,0,0-.7-1.28,1.616,1.616,0,0,0-.96-.16,1.789,1.789,0,0,0-1.216.384,3,3,0,0,0-.8,1.7,9.736,9.736,0,0,1-2.145,4,6.024,6.024,0,0,0-1.12,1.441,1.735,1.735,0,0,0-.032,1.761C165.675,259.276,166.187,259.532,166.379,260.012Z",
    transform: "translate(-165.193 -249.565)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386",
    transform: "translate(2.747 9.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M170.354,275.419a1.858,1.858,0,0,1-.448,1.184,2.457,2.457,0,0,1-1.249.544,1.776,1.776,0,0,1-1.152,0,1.859,1.859,0,0,1-.736-1.024,5.184,5.184,0,0,1-.384-1.377,1.8,1.8,0,0,1,.352-1.345,1.62,1.62,0,0,1,1.024-.544,2.159,2.159,0,0,1,1.857.672A2.529,2.529,0,0,1,170.354,275.419Z",
    transform: "translate(-166.377 -272.838)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    transform: "translate(0.642 9.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M164.058,277.426a2.674,2.674,0,0,1-2.177-.416,7.006,7.006,0,0,1-2.081-1.921,2.748,2.748,0,0,0,1.5-1.889,7.784,7.784,0,0,0,1.921.544,2.892,2.892,0,0,1,1.729.992,1.99,1.99,0,0,1,.224,1.6A2.07,2.07,0,0,1,164.058,277.426Z",
    transform: "translate(-159.8 -273.2)",
    fill: "#e7a988"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(1.026 9.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M165.706,274.637a2.719,2.719,0,0,0-1.729-.992,8.2,8.2,0,0,1-1.921-.544A2.586,2.586,0,0,1,161,274.733c1.344.928,3.521.768,4.129,1.953a.943.943,0,0,1,.16.416,1.656,1.656,0,0,0,.608-.864A1.763,1.763,0,0,0,165.706,274.637Z",
    transform: "translate(-161 -273.1)",
    fill: "#d88568"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 2.177,
    height: 16.198,
    transform: "matrix(0.969, -0.249, 0.249, 0.969, 0, 0.542)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    transform: "translate(0.13 5.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M158.232,262.981a3.92,3.92,0,0,1,.064-.608,21.473,21.473,0,0,0,.992-3.073c.7.96.224,1.729.256,2.113a6.58,6.58,0,0,1,1.12.064.355.355,0,0,1,.288.224.249.249,0,0,1-.1.224c-.064.064-.16.064-.224.1a.639.639,0,0,1,.32.256.473.473,0,0,1,.128.416c-.032.128-.192.256-.32.192a.723.723,0,0,1,.256.352c.032.16-.1.32-.224.288a.43.43,0,0,1,.064.48c-.1.16-.224.256-.32.416a6.877,6.877,0,0,0-.448.832,1.052,1.052,0,0,1-.672.608.984.984,0,0,1-.832-.384,1.537,1.537,0,0,1-.288-.352,1.218,1.218,0,0,1-.1-.576C158.2,264.038,158.2,263.494,158.232,262.981Z",
    transform: "translate(-158.2 -259.3)",
    fill: "#e7a988"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408",
    transform: "translate(1.314 7.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M163.469,266.764a2.25,2.25,0,0,0-.32-.256c.1-.032.16-.032.224-.1s.128-.128.1-.224a.354.354,0,0,0-.288-.224,4.378,4.378,0,0,0-.928-.064,5.046,5.046,0,0,1-.352,4.45h0a1.132,1.132,0,0,0,.672-.608,5.1,5.1,0,0,1,.448-.832,2.054,2.054,0,0,0,.32-.416.347.347,0,0,0-.064-.48c.128.032.256-.16.224-.288a.57.57,0,0,0-.256-.352c.128.064.288-.064.32-.192A.418.418,0,0,0,163.469,266.764Z",
    transform: "translate(-161.9 -265.9)",
    fill: "#d88568"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(1.57 8.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    transform: "translate(0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M164.016,269.88a2.648,2.648,0,0,0-1.216-.32v-.16a2.567,2.567,0,0,1,1.281.352Z",
    transform: "translate(-162.8 -269.4)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412",
    transform: "translate(0 0.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M163.948,271.916a3.222,3.222,0,0,0-1.248-.256v-.16a3.718,3.718,0,0,1,1.313.288Z",
    transform: "translate(-162.7 -271.5)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414",
    transform: "translate(0 1.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M163.66,274.34a.522.522,0,0,1-.352-.416c0-.032,0-.064-.032-.064h-.064a2.42,2.42,0,0,0-.48.032l-.032-.16a2.59,2.59,0,0,1,.512-.032.207.207,0,0,1,.16.064c.064.032.064.1.064.16a.44.44,0,0,0,.256.32Z",
    transform: "translate(-162.7 -273.7)",
    fill: "#022a44"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451",
    transform: "translate(11.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435",
    transform: "translate(1.184 6.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(0.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M186.037,225a12.926,12.926,0,0,0,2.145-.7,18.7,18.7,0,0,0,1.184,4.1l.224.32a13.6,13.6,0,0,1-5.09,2.3C186.677,229.838,185.941,227.117,186.037,225Z",
    transform: "translate(-184.5 -224.3)",
    fill: "#e7a988"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    transform: "translate(0.736 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M187.861,224.6a8.147,8.147,0,0,1-1.825.608c-.1,2.113.64,4.834-1.537,6.05.768-.224,1.5-.448,2.209-.7A13.739,13.739,0,0,0,187.861,224.6Z",
    transform: "translate(-184.5 -224.6)",
    fill: "#d88568"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(2.145 0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M190.853,224.5a9.283,9.283,0,0,1-1.953.64c.032.9.16,1.921.128,2.881C190.533,227.733,190.757,226.037,190.853,224.5Z",
    transform: "translate(-188.9 -224.5)",
    fill: "#022a44"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(0 3.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M183.865,237.531a2.585,2.585,0,0,0-1.056.8,7.67,7.67,0,0,0-.608,2.113,8.16,8.16,0,0,1,3.137-1.921,19.23,19.23,0,0,1,3.617-.864.78.78,0,0,0-.384-.768,2.062,2.062,0,0,0-.9-.224A7.247,7.247,0,0,0,183.865,237.531Z",
    transform: "translate(-182.2 -236.651)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445",
    transform: "translate(0 1.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M184.23,212.409A3.965,3.965,0,0,0,181.8,211h-.608c-.384.448-.608.48-.9.992l-.1.384a.917.917,0,0,1-.512.672,4.247,4.247,0,0,0-.96.576.434.434,0,0,0-.224.352c0,.128.1.192.16.288l.512.512a10.807,10.807,0,0,0,.064,1.761,1.628,1.628,0,0,0,.192.96,1.186,1.186,0,0,0,.768.384,4.457,4.457,0,0,0,3.265-.8,3.471,3.471,0,0,0,1.409-1.825A3.087,3.087,0,0,0,184.23,212.409Z",
    transform: "translate(-178.5 -211)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441",
    transform: "translate(1.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M187.9,212.409A3.965,3.965,0,0,0,185.469,211h-.608c-.384.448-.608.48-.9.992l-.064.224c.1,1.761,1.953,3.617,2.433,5.378a6.878,6.878,0,0,0,.832-.448,3.472,3.472,0,0,0,1.409-1.825A3.277,3.277,0,0,0,187.9,212.409Z",
    transform: "translate(-183.9 -211)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444",
    transform: "translate(1.697 1.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M183.8,214.756a.8.8,0,0,0,.032-.256Z",
    transform: "translate(-183.8 -214.5)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M192.216,206.85a13.978,13.978,0,0,0-.768-1.312c-.128-.192-.288-.416-.512-.448a.757.757,0,0,0-.608.256c-.192.128-.384.288-.576.416a7.5,7.5,0,0,0-.864-.448,3.728,3.728,0,0,0-2.817.128l-.864-.288a2.388,2.388,0,0,0-.864,1.729,5.375,5.375,0,0,0,.768,3.3,8.025,8.025,0,0,0,2.593,2.689,1.733,1.733,0,0,0,1.537-.064c.064-.032.1-.032.128-.064a3.45,3.45,0,0,0,.768-.384,7.322,7.322,0,0,0,1.793-1.921,3.742,3.742,0,0,0,.8-2.081A3.662,3.662,0,0,0,192.216,206.85Z",
    transform: "translate(-182.452 -205.085)",
    fill: "#022a44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447",
    transform: "translate(2.568 1.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1446",
    "data-name": "Group 1446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M186.8,210.712a2.426,2.426,0,0,0,.352,1.216c.032-.288.064-.608.1-.9a1.828,1.828,0,0,0,.672.416c.032-.192.1-.384.128-.576a.883.883,0,0,0,.448.384,3.78,3.78,0,0,1,.16-.352.325.325,0,0,0,.32.16c.032-.1.064-.224.1-.32a.274.274,0,0,0,.352.224.282.282,0,0,0,.16-.384c.128.1.224.16.352.256a.155.155,0,0,0,0-.224,3,3,0,0,0,1.408.032,2.8,2.8,0,0,1-.928-1.249.452.452,0,0,1-.256.48.485.485,0,0,1-.544-.032,2.2,2.2,0,0,0-.352.416.557.557,0,0,0-.48-.16,2.4,2.4,0,0,0-.512.128,2.23,2.23,0,0,1-1.633-.224,3.025,3.025,0,0,0,.224,2.241A2.542,2.542,0,0,1,186.8,210.712Z",
    transform: "translate(-186.523 -209.4)",
    fill: "#2070b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449",
    transform: "translate(6.919 0.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M200.622,207.362a9.262,9.262,0,0,0,.352,1.633,1.853,1.853,0,0,1-.8-1.184c-.032-.128-.1-.256-.032-.384C200.238,207.169,200.462,207.618,200.622,207.362Z",
    transform: "translate(-200.114 -207.343)",
    fill: "#ffd255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(5.128 34.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    transform: "translate(0 12.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M158.428,371.7a9.219,9.219,0,0,0,3.361-3.809c1.024-12.613,0-11.812.512-17.287h4.034a34.384,34.384,0,0,1-.672,9.8c-.576,2.529-1.088,4.45-1.665,7.459a5.735,5.735,0,0,0-.1,1.953,1.491,1.491,0,0,1-.032,1.12c-.48.736-.96.576-1.793.9-.992.352-.8,1.12-2.817,1.184a1.7,1.7,0,0,1-1.12-.224.637.637,0,0,1-.256-.384C157.82,372.048,158.172,371.856,158.428,371.7Z",
    transform: "translate(-157.876 -350.6)",
    fill: "#e7a988"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461",
    transform: "translate(4.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    "data-name": "Group 1458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M173.425,364.877c.352-1.537.672-2.881,1.056-4.482a34.464,34.464,0,0,0,.672-9.8H171.12c-.48,5.058.352,4.738-.32,14.565A1.825,1.825,0,0,0,173.425,364.877Z",
    transform: "translate(-170.8 -350.6)",
    fill: "#d88568"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(0.808 20.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M163.377,414.9a3.329,3.329,0,0,1-1.344.672,2.047,2.047,0,0,1-1.441-.16l-.192-.1a2.238,2.238,0,0,1,.32-.256.242.242,0,0,1,.128-.064.166.166,0,0,1,.128.064,1.351,1.351,0,0,0,.608.1A4.14,4.14,0,0,0,163.377,414.9Z",
    transform: "translate(-160.4 -414.9)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(0 19.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M158.428,412.693a4.715,4.715,0,0,0,.416-.288,1.952,1.952,0,0,0,1.537.416,8.242,8.242,0,0,0,3.553-1.921,1.248,1.248,0,0,1-.064,1.024c-.48.736-.96.576-1.793.9-.992.352-.8,1.121-2.817,1.184a1.7,1.7,0,0,1-1.12-.224.637.637,0,0,1-.256-.384C157.82,413.045,158.172,412.853,158.428,412.693Z",
    transform: "translate(-157.876 -410.9)",
    fill: "#ffd255"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(3.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M169.943,312.5c.064,1.921-.16,4.258-.224,6.178-.064,1.953-.32,3.906-.32,5.858-.032,4.61,1.088,9.284.128,13.733a7.34,7.34,0,0,0,5.218-.224c.608-7.3,1.409-17.094,2.625-25C175.161,313.236,172.024,313.428,169.943,312.5Z",
    transform: "translate(-169.398 -312.5)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476",
    transform: "translate(2.914 1.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M182.982,318.032a6.565,6.565,0,0,1-1.12-.032,2.785,2.785,0,0,1-.064,1.344c-1.152,3.233-3.233,8.035-3.233,10.948,0,4.258,0,7.619-.064,12.165a6.65,6.65,0,0,0,2.465-.608C181.573,334.518,181.765,325.907,182.982,318.032Z",
    transform: "translate(-178.5 -318)",
    fill: "#022a44"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511",
    transform: "translate(9.64 33.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(3.275 13.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(0.004 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M184.322,375.052l.832-.672a3.707,3.707,0,0,0,.64-2.721c-.7-5.57-2.529-12.453-3.393-17.959h4.994c.736,5.794,1.569,12.709.448,18.183a6.1,6.1,0,0,0-.064,2.017c.064.448.128.864.16,1.312a1.8,1.8,0,0,1-.16,1.184c-.192.224-.864.1-1.408.352a4.839,4.839,0,0,1-4,.288C181.761,376.557,183.041,375.788,184.322,375.052Z",
    transform: "translate(-182.213 -353.7)",
    fill: "#e7a988"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    transform: "translate(0.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M187.794,353.6H182.8c.832,5.314,2.593,11.908,3.329,17.383a2.008,2.008,0,0,0,2.4-.736C189.2,365.06,188.466,358.882,187.794,353.6Z",
    transform: "translate(-182.8 -353.6)",
    fill: "#d88568"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491",
    transform: "translate(5.217 20.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M198.692,418.952a1.315,1.315,0,0,0,.032-.352,3.559,3.559,0,0,0-.224.512c.032.032.1,0,.128-.032S198.66,419.016,198.692,418.952Z",
    transform: "translate(-198.5 -418.6)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494",
    transform: "translate(0.704 21.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M186.385,422.824a3.284,3.284,0,0,1-.768.16,1.443,1.443,0,0,1-1.217-.736,3.6,3.6,0,0,0,.416-.32,2.507,2.507,0,0,0,2.081.352c.7-.128,1.408-.416,2.113-.48A26.168,26.168,0,0,1,186.385,422.824Z",
    transform: "translate(-184.4 -421.8)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(0 21.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M183.1,421.408a1.5,1.5,0,0,0,.864.544,3.319,3.319,0,0,0,1.921-.32,15.737,15.737,0,0,1,2.017-.832,1.8,1.8,0,0,1-.16,1.185c-.192.224-.864.1-1.408.352a4.838,4.838,0,0,1-4,.288C181.977,422.337,182.393,421.888,183.1,421.408Z",
    transform: "translate(-182.202 -420.8)",
    fill: "#ffd255"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(2.73 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M187.735,312.476c.864,3.2-.288,6.562-.7,9.86-.7,5.826,2.433,12.549,1.313,18.311-1.729.833-3.585,1.5-5.538.48.32-3.457-.7-8-1.28-11.428-.288-1.761-.768-3.489-.928-5.25-.384-4.354,1.056-8.867-.1-13.061l6.114-.288Z",
    transform: "translate(-180.5 -311.1)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(0 0.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M179.887,315.009a3.071,3.071,0,0,0,1.088-.32.983.983,0,0,0,.512-.928q-4.706-.288-9.412-.96a.9.9,0,0,0,.032.9,1.924,1.924,0,0,0,.7.64,7.559,7.559,0,0,0,3.457.96A17.072,17.072,0,0,0,179.887,315.009Z",
    transform: "translate(-171.971 -312.8)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510",
    transform: "translate(7.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M197.8,322.268c.416-3.3,1.537-6.659.7-9.86L197.42,311c-.384.032-.736.032-1.12.064a6,6,0,0,1,1.184,3.874c-1.28,7.363,0,13.765.96,20.808a17.07,17.07,0,0,1,.192,5.09c.16-.064.32-.16.512-.224C200.237,334.849,197.068,328.127,197.8,322.268Z",
    transform: "translate(-196.3 -311)",
    fill: "#022a44"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(9.297 10.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1515",
    "data-name": "Group 1515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M182.3,238.267a4.268,4.268,0,0,1,.9,3.361,12.626,12.626,0,0,1-1.569,4.674,6.8,6.8,0,0,0-.928,4.8,15.937,15.937,0,0,0,.9,2.721,20.71,20.71,0,0,1,1.313,7.267,1.781,1.781,0,0,1-.288,1.152,1.517,1.517,0,0,1-1.152.416c-2.977.16-7.171.32-10.564-.96.16-4.642,2.017-8.579,2.177-13.221.1-2.209-1.024-3.745-.16-5.762a12.458,12.458,0,0,1,5.09-4.8C179.383,237.243,181.208,237.115,182.3,238.267Z",
    transform: "translate(-170.9 -237.404)",
    fill: "#ffd255"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519",
    transform: "translate(12.178 17.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M180.092,269.4c.1-2.433.928-4.8.832-7.267a20,20,0,0,0,6.4-3.937c-1.056,2.5-2.177,5.186-1.729,7.875a20.7,20.7,0,0,0,1.793,4.866,8.622,8.622,0,0,1,.512,5.506,20.208,20.208,0,0,1-8-.384C180.508,273.918,180,271.645,180.092,269.4Z",
    transform: "translate(-179.9 -258.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521",
    transform: "translate(11.903 16.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M179.123,263.526a3.5,3.5,0,0,1,.576-1.793,3.977,3.977,0,0,1,1.377-1.024c2.017-1.088,4.1-2.113,6.242-3.009a22.992,22.992,0,0,1-6.819,9,1.085,1.085,0,0,1-.9.32c-.416-.128-.512-.64-.544-1.056A15.537,15.537,0,0,1,179.123,263.526Z",
    transform: "translate(-179.04 -257.7)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523",
    transform: "translate(9.921 11.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M172.963,264.5a14.545,14.545,0,0,1,.736-6.178c.224-.8.448-1.633.608-2.433a37.49,37.49,0,0,0,.512-4.194,36.206,36.206,0,0,1,.416-3.745c.384-2.241,1.376-5.25,3.873-6.851l.1.128c-2.433,1.569-3.393,4.546-3.777,6.755a37.224,37.224,0,0,0-.416,3.745,32.353,32.353,0,0,1-.512,4.226c-.16.8-.384,1.633-.608,2.433a13.832,13.832,0,0,0-.736,6.114Z",
    transform: "translate(-172.851 -241.1)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1525",
    "data-name": "Group 1525",
    transform: "translate(0 6.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1524",
    "data-name": "Group 1524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M161.655,230.526a4.179,4.179,0,0,0-2.785.736c-1.216.736-2.4,1.6-3.585,2.433a7.892,7.892,0,0,1-3.905,1.6c-1.985-2.241-3.233-2.785-5.154-4.93a3.962,3.962,0,0,1-.48-1.056,7.81,7.81,0,0,0-.672-1.7.444.444,0,0,0-.256-.224.869.869,0,0,0-.288,0,.993.993,0,0,1-.576-.288c-.672-.512-1.344-1.056-2.017-1.6-.288.544.256.8,1.152,1.665-.192-.032-.544.288-.512.512a1.939,1.939,0,0,1,0,.608c-.064.16-.192.32-.128.48.032.1.128.128.16.224.064.128,0,.256,0,.384a.953.953,0,0,0,.256.576,3.507,3.507,0,0,0,.672.7,5.233,5.233,0,0,0,.608.288,1.8,1.8,0,0,1,.7.832c.032.064.224.48.256.544a52.8,52.8,0,0,0,4,6.563,1.412,1.412,0,0,0,1.184.512,26.393,26.393,0,0,0,9.764-2.849,8.4,8.4,0,0,0,2.017-1.312,3.218,3.218,0,0,0,1.216-2.529A2.226,2.226,0,0,0,161.655,230.526Z",
    transform: "translate(-141.858 -225.5)",
    fill: "#e7a988"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1539",
    "data-name": "Group 1539",
    transform: "translate(0.718 10.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1527",
    "data-name": "Group 1527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    "data-name": "Group 1526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M163.179,238.82a4.18,4.18,0,0,0-2.785.736c-1.216.736-2.4,1.6-3.585,2.433a7.892,7.892,0,0,1-3.906,1.6c-.256-.288-.512-.576-.768-.832a4.7,4.7,0,0,1-.416.288c-2.241,1.28-4.482-1.6-5.442-3.841-.32-.608-1.5-.64-2.177-1.5a.954.954,0,0,0,.256.544,3.508,3.508,0,0,0,.672.7,5.232,5.232,0,0,0,.608.288,1.8,1.8,0,0,1,.7.832c.032.064.224.48.256.544a52.8,52.8,0,0,0,4,6.562,1.412,1.412,0,0,0,1.184.512,26.391,26.391,0,0,0,9.764-2.849,8.4,8.4,0,0,0,2.017-1.312A3.217,3.217,0,0,0,164.78,241,2.165,2.165,0,0,0,163.179,238.82Z",
    transform: "translate(-144.1 -237.7)",
    fill: "#d88568"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1538",
    "data-name": "Group 1538",
    transform: "translate(7.642 0.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1529",
    "data-name": "Group 1529",
    transform: "translate(0 0.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    "data-name": "Group 1528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M178.512,240.158a5.293,5.293,0,0,0-2.241,1.12A20.075,20.075,0,0,1,170.765,244a4.542,4.542,0,0,0-1.28.544,1.385,1.385,0,0,0-.672,1.152c.032.416.288.8.256,1.216-.032.448-.416.8-.7,1.152s-.544.864-.288,1.248a1.216,1.216,0,0,0,.736.416,5.073,5.073,0,0,1,1.216.48,1.541,1.541,0,0,1,.768,1.024,7.228,7.228,0,0,1-.032.832.863.863,0,0,0,.288.736.834.834,0,0,0,.48.128c.832,0,1.408-.768,1.953-1.409,1.857-2.049,4.674-3.009,6.53-5.09a5.649,5.649,0,0,0,1.344-2.465,3.532,3.532,0,0,0-.448-2.721A2.7,2.7,0,0,0,178.512,240.158Z",
    transform: "translate(-167.971 -240.139)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1531",
    "data-name": "Group 1531",
    transform: "translate(1.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    "data-name": "Group 1530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M171.528,244.514l-.128-.1a2.845,2.845,0,0,1,1.761-1.088c.256-.064.544-.1.8-.16a7.449,7.449,0,0,0,1.216-.256,7.008,7.008,0,0,0,2.241-1.408l.224-.192A9.475,9.475,0,0,1,179.6,239.9a3.159,3.159,0,0,1,2.657-.224l-.064.16a3.1,3.1,0,0,0-2.529.224,10.039,10.039,0,0,0-1.921,1.376l-.224.192a7.04,7.04,0,0,1-2.3,1.441,8.658,8.658,0,0,1-1.248.256,7.057,7.057,0,0,0-.8.16A2.783,2.783,0,0,0,171.528,244.514Z",
    transform: "translate(-171.4 -239.482)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1533",
    "data-name": "Group 1533",
    transform: "translate(1.13 5.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    "data-name": "Group 1532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M174.7,257.2a5.078,5.078,0,0,1-2.369.576.965.965,0,0,0-.672.16,1.561,1.561,0,0,1-.16,1.249,3.358,3.358,0,0,1,1.441-.8A5.679,5.679,0,0,0,174.7,257.2Z",
    transform: "translate(-171.5 -257.2)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1535",
    "data-name": "Group 1535",
    transform: "translate(0.842 6.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    "data-name": "Group 1534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M177.675,260.4a47.2,47.2,0,0,1-4.994,4.1,3.527,3.527,0,0,0-2.081-1.056,9.663,9.663,0,0,0,3.745-1.056A29.448,29.448,0,0,0,177.675,260.4Z",
    transform: "translate(-170.6 -260.4)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1537",
    "data-name": "Group 1537",
    transform: "translate(3.21 6.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M178.992,265.306a16.206,16.206,0,0,0,2.337-2.113,17.562,17.562,0,0,1,2.721-1.825A4.541,4.541,0,0,0,186.259,259a7.331,7.331,0,0,1-2.849,2.465,30.1,30.1,0,0,0-3.3,1.857A12.42,12.42,0,0,0,178,265.306a.479.479,0,0,0,.48.192A.907.907,0,0,0,178.992,265.306Z",
    transform: "translate(-178 -259)",
    fill: "#faa701"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543",
    transform: "translate(11.986 5.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1542",
    "data-name": "Group 1542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M179.684,221.228c.064.032.128.032.192.1s.1.128.064.192-.128.128-.16.064a2.273,2.273,0,0,1-.48-.48A1.8,1.8,0,0,0,179.684,221.228Z",
    transform: "translate(-179.3 -221.1)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1789",
    "data-name": "Group 1789",
    transform: "translate(154.54 72.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    transform: "translate(0.173 0.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1547",
    "data-name": "Group 1547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1545",
    "data-name": "Group 1545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M549.115,265.917c-.032-.224-.192-.416-.192-.672,0-.16.064-.32.064-.448a1.669,1.669,0,0,0-.224-.672,2.662,2.662,0,0,1-.224-.864.82.82,0,0,0-.416.32.742.742,0,0,0-.1.512c.032.192.16.384.128.576l-.1.192-.032-.032c-.16-.16-.352-.288-.544-.448a8.813,8.813,0,0,1-1.569-1.7.262.262,0,0,0-.32-.128.382.382,0,0,0-.064.416,4.916,4.916,0,0,0,.928,1.5.663.663,0,0,1,.128.192c.032.1-.032.192-.064.288l-.288.672a1.076,1.076,0,0,0-.064.7,1.129,1.129,0,0,0,.256.416,1.553,1.553,0,0,0,.864.64,2.294,2.294,0,0,0,.672.064,11.866,11.866,0,0,1,1.761,1.825,5.749,5.749,0,0,1,1.377-1.088c-.672-.64-1.344-1.312-1.953-1.985A.888.888,0,0,0,549.115,265.917Z",
    transform: "translate(-545.496 -262.535)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1550",
    "data-name": "Group 1550",
    transform: "translate(0.837 2.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1549",
    "data-name": "Group 1549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M548.171,270.857a1.064,1.064,0,0,1,0-.7l.192-1.152a1.332,1.332,0,0,0,.576.256.836.836,0,0,1,.512.352.475.475,0,0,1,.032.224c.032.384.1.768.128,1.185a1.118,1.118,0,0,1-.768.32A.9.9,0,0,1,548.171,270.857Z",
    transform: "translate(-548.111 -269)",
    fill: "#d88568"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554",
    transform: "translate(0.598 1.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M547.727,269.168a2.689,2.689,0,0,0,.384.256c.064.032.16.1.224.064a.264.264,0,0,0,.128-.192.707.707,0,0,0-.192-.48,2.062,2.062,0,0,0-.416-.32.681.681,0,0,0-.224-.1.272.272,0,0,0-.256.224.382.382,0,0,0,.1.352A1.787,1.787,0,0,0,547.727,269.168Z",
    transform: "translate(-547.363 -268.4)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558",
    transform: "translate(0.404 2.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1555",
    "data-name": "Group 1555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M546.772,270.761c.032.128.16.192.288.256s.256.16.416.224a1.13,1.13,0,0,0,.288.128.258.258,0,0,0,.288-.1.251.251,0,0,0,.032-.256.575.575,0,0,0-.16-.224,1.9,1.9,0,0,0-.864-.544.143.143,0,0,0-.16,0,.176.176,0,0,0-.1.16A.635.635,0,0,0,546.772,270.761Z",
    transform: "translate(-546.759 -270.225)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562",
    transform: "translate(0.448 3.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1561",
    "data-name": "Group 1561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1560",
    "data-name": "Group 1560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M546.929,272.792a.4.4,0,0,0,.064.416.906.906,0,0,0,.352.256,1.952,1.952,0,0,0,.416.1c.064,0,.16.032.224,0a.264.264,0,0,0,.192-.128c.064-.1,0-.224-.1-.32a3.971,3.971,0,0,0-.384-.256l-.384-.192a.6.6,0,0,0-.224-.064A.427.427,0,0,0,546.929,272.792Z",
    transform: "translate(-546.896 -272.6)",
    fill: "#e7a988"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586",
    transform: "translate(2.847 4.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566",
    transform: "translate(0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M573.886,281.144l-1.377-.48a24.106,24.106,0,0,1-16.9-6.018.487.487,0,0,0-.64,0,3.627,3.627,0,0,0-.736.832,1.632,1.632,0,0,0-.224,1.473,2.858,2.858,0,0,0,.8.96,54.26,54.26,0,0,0,6.723,5.058,17.478,17.478,0,0,0,7.907,2.657,5.632,5.632,0,0,0,3.809-.928A2.682,2.682,0,0,0,573.886,281.144Z",
    transform: "translate(-553.915 -274.525)",
    fill: "#98a9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(1.169 1.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568",
    transform: "translate(11.941 5.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M595.248,295.424a.224.224,0,1,1-.224-.224A.219.219,0,0,1,595.248,295.424Z",
    transform: "translate(-594.8 -295.2)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(8.867 6.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M585.584,300.392a.192.192,0,1,1-.192-.192A.184.184,0,0,1,585.584,300.392Z",
    transform: "translate(-585.2 -300.2)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(8.579 3.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 0.288,
    cy: 0.288,
    r: 0.288,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574",
    transform: "translate(5.154 2.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 0.16,
    cy: 0.16,
    r: 0.16,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(3.041 2.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M567.448,287.224a.224.224,0,1,1-.224-.224A.219.219,0,0,1,567.448,287.224Z",
    transform: "translate(-567 -287)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578",
    transform: "translate(1.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1577",
    "data-name": "Group 1577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M561.384,279.592a.192.192,0,1,1-.192-.192C561.288,279.432,561.384,279.5,561.384,279.592Z",
    transform: "translate(-561 -279.4)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    transform: "translate(0 0.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 0.256,
    cy: 0.256,
    r: 0.256,
    fill: "#e8e9eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583",
    transform: "translate(0 1.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M554.056,278.1a1.627,1.627,0,0,0-.128,1.281,2.858,2.858,0,0,0,.8.96,54.262,54.262,0,0,0,6.723,5.058,17.478,17.478,0,0,0,7.907,2.657,5.633,5.633,0,0,0,3.809-.928,2.813,2.813,0,0,0,.96-1.441A22.129,22.129,0,0,1,554.056,278.1Z",
    transform: "translate(-553.847 -278.1)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(7.664 4.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M577.856,290.1a1.833,1.833,0,0,0,.576,1.889A3.286,3.286,0,0,0,577.856,290.1Z",
    transform: "translate(-577.788 -290.1)",
    fill: "#7d95c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598",
    transform: "translate(6.654 19.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(2.869 35.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M575.884,431.1a1.185,1.185,0,1,0,1.185,1.185A1.2,1.2,0,0,0,575.884,431.1Z",
    transform: "translate(-574.7 -431.1)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    transform: "translate(3.541 16.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M599.337,391.187v-.224h0v-.288a.52.52,0,0,0-.48-.512c-1.408-.128-5.506-.448-7.074-.64a4.11,4.11,0,0,1-2.721-1.248H588.8v-6.562h-.256V372.3h-.96v9.412h-.256v6.562h-.256a4.109,4.109,0,0,1-2.721,1.248c-1.569.192-5.7.512-7.075.64a.547.547,0,0,0-.48.512v.288h.192v.832h.768v-.9l8.9-.7a6.471,6.471,0,0,1-.576.416,1.688,1.688,0,0,0-.448.384.65.65,0,0,0-.128.256h-.576v2.209h1.953v-2.209h-.608a.24.24,0,0,1,.032-.16,3.906,3.906,0,0,0,2.081-.96l10.148.832v.288a1.217,1.217,0,0,0-.8,1.12,1.185,1.185,0,0,0,2.369,0A1.135,1.135,0,0,0,599.337,391.187Z",
    transform: "translate(-576.8 -372.3)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593",
    transform: "translate(0 0.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M566.719,342.077a2.112,2.112,0,0,0-.928,2.049c.288.992,1.6,1.152,2.625,1.12l11.332-.192c2.5-.032,5.186-.16,7.107-1.729a9.657,9.657,0,0,0,2.721-4.482,29.641,29.641,0,0,0,1.633-7.427,9.6,9.6,0,0,0-.7-5.026,4.2,4.2,0,0,0-4.13-2.465,4.429,4.429,0,0,0-2.881,1.953,11.076,11.076,0,0,0-1.377,3.3c-.832,2.785-1.633,5.794-3.809,7.715C575.074,339.708,569.952,339.324,566.719,342.077Z",
    transform: "translate(-565.739 -323.891)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1594",
    "data-name": "Group 1594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M566.719,339.777a2.112,2.112,0,0,0-.928,2.049c.288.992,1.6,1.152,2.625,1.12l11.332-.192c2.5-.032,5.186-.16,7.107-1.729a9.658,9.658,0,0,0,2.721-4.482,29.64,29.64,0,0,0,1.633-7.427,9.6,9.6,0,0,0-.7-5.026,4.2,4.2,0,0,0-4.13-2.465,4.429,4.429,0,0,0-2.881,1.953,11.075,11.075,0,0,0-1.377,3.3c-.832,2.785-1.633,5.794-3.809,7.715C575.074,337.408,569.952,337.024,566.719,339.777Z",
    transform: "translate(-565.739 -321.591)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597",
    transform: "translate(2.464 2.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M593.529,329.848a2,2,0,0,1,1.281,1.665,5.219,5.219,0,0,1-.224,2.209c-.416,1.729-.9,3.425-1.44,5.122-.672,2.017-1.473,4.13-3.073,5.538-1.7,1.537-4.033,2.081-6.306,2.4a48.122,48.122,0,0,1-8.035.416c-.8-.032-1.729-.128-2.113-.832a1.6,1.6,0,0,1,0-1.473,3.456,3.456,0,0,1,.992-1.152c2.177-1.761,5.026-2.4,7.427-3.841a12.382,12.382,0,0,0,4.738-5.346c.416-.928.736-1.889,1.184-2.785a5.322,5.322,0,0,1,1.921-2.273,2.747,2.747,0,0,1,2.881-.032Z",
    transform: "translate(-573.437 -329.071)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624",
    transform: "translate(0 25.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(0 19.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602",
    transform: "translate(0.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M546.743,409.115a8.946,8.946,0,0,0,2.465-1.248,2.8,2.8,0,0,0,1.056-2.4,24.577,24.577,0,0,0-.256-3.746c-.032-.384-.064-.768-.128-1.12h3.265a20.836,20.836,0,0,0,.032,7.715,1.788,1.788,0,0,1-.128,1.472,1.293,1.293,0,0,1-1.216.32,3.592,3.592,0,0,0-1.153-.1c-1.408.224-2.817.672-4.129.32-.256-.064-.7-.224-.768-.48C545.686,409.563,546.455,409.243,546.743,409.115Z",
    transform: "translate(-545.774 -400.6)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(0.271 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M553.195,408.415a20.179,20.179,0,0,1-.032-7.715H549.9c.032.384.064.736.128,1.12.032.448.1.96.16,1.472,1.216.448,1.537,1.985,2.081,3.073.64,1.6-.96,2.561-2.241,2.881a19.745,19.745,0,0,1-4.226.7v.032c.064.256.512.416.768.48,1.312.352,2.753-.1,4.13-.32a3.442,3.442,0,0,1,1.152.1,1.273,1.273,0,0,0,1.217-.32A1.888,1.888,0,0,0,553.195,408.415Z",
    transform: "translate(-545.8 -400.7)",
    fill: "#d88568"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(0 8.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M546.506,428.389a2.261,2.261,0,0,1-1.28-.416c-.16-.128-.32-.32-.256-.512a.64.64,0,0,1,.256-.32,3.394,3.394,0,0,1,1.088-.512.57.57,0,0,0,.32.512,1.359,1.359,0,0,0,.608.192,7.675,7.675,0,0,0,2.817-.256,21.523,21.523,0,0,1,2.785-.576,1.117,1.117,0,0,1-.544,1.216,3.759,3.759,0,0,1-1.7.1,9.048,9.048,0,0,0-2.017.416A6.607,6.607,0,0,1,546.506,428.389Z",
    transform: "translate(-544.955 -426.5)",
    fill: "#2070b4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    transform: "translate(4.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1612",
    "data-name": "Group 1612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M558.724,403.289c0-.512-.064-1.024-.1-1.569-.032-.384-.064-.768-.128-1.12h3.265a25.606,25.606,0,0,0-.32,2.689Z",
    transform: "translate(-558.5 -400.6)",
    fill: "#7d95c9"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(2.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M558.484,361.388l-3.745.16a.926.926,0,0,1-.9-.8c-.64-4.482-1.665-7.395-.864-11.428a4.086,4.086,0,0,1,3.169-2.945c3.809-.7,9.54-1.216,9.891-5.474l5.6,1.056c.128,1.953.128,6.531-1.7,9.188l-12,.832C558.068,355.657,558.132,357.45,558.484,361.388Z",
    transform: "translate(-552.685 -340.9)",
    fill: "#2070b4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(4.094 6.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M574.824,360.5c-4.93.736-10.276.192-15.109,1.889-.961.64-2.241,1.6-1.921,2.881.384,3.3.544,6.467.8,9.6l3.3-.16c-.352-3.937-.416-5.73-.576-9.412l12-.832A9.944,9.944,0,0,0,574.824,360.5Z",
    transform: "translate(-557.743 -360.5)",
    fill: "#22619c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653",
    transform: "translate(2.615 26.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(0 22.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(0.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M555.139,419.615c.608-.352,1.761-.864,2.529-1.28a2.1,2.1,0,0,0,1.28-1.793,24.519,24.519,0,0,0-.288-4.322c-.032-.384-.064-.768-.128-1.12H561.8c-.1,2.689-.448,5.186.032,7.715a1.788,1.788,0,0,1-.128,1.473c-.48.576-1.377.352-2.017.352a19.051,19.051,0,0,0-2.337.128,5.545,5.545,0,0,1-2.177.064.744.744,0,0,1-.576-.48C554.563,420.063,554.851,419.775,555.139,419.615Z",
    transform: "translate(-554.592 -411.1)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(6.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M574.784,418.815c-.512-2.529-.128-5.026-.032-7.715H573.6c.352,3.233.8,6.627.192,9.572a1.209,1.209,0,0,0,.864-.384A1.788,1.788,0,0,0,574.784,418.815Z",
    transform: "translate(-573.6 -411.1)",
    fill: "#d88568"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636",
    transform: "translate(3.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M566.949,413.821a14.078,14.078,0,0,0-.16-1.633c-.032-.384.1-.7.064-1.088l3.489.032a19.025,19.025,0,0,0-.224,2.689Z",
    transform: "translate(-566.784 -411.1)",
    fill: "#7d95c9"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641",
    transform: "translate(0 8.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M553.181,437.648a2.072,2.072,0,0,0,1.44.768,6.376,6.376,0,0,0,1.345-.128,10.837,10.837,0,0,1,2.689-.128,8.547,8.547,0,0,0,1.28.032,2.242,2.242,0,0,0,1.28-.48c.288-.32,0-.96-.256-1.312a5.743,5.743,0,0,1-3.073.9c-.64.032-1.281.128-1.921.1-.448,0-1.152.064-1.28-.512a.5.5,0,0,1,.16-.448c-.256-.128-.608.288-1.056.48a1.476,1.476,0,0,0-.576.32A.339.339,0,0,0,553.181,437.648Z",
    transform: "translate(-553.125 -436.4)",
    fill: "#2070b4"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646",
    transform: "translate(2.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M565.7,365.893h-2.977a1.035,1.035,0,0,1-1.024-.9l-1.12-8.419c-.16-1.217-.416-2.721.16-3.809a4.936,4.936,0,0,1,1.473-1.857c2.753-1.889,6.627-2.4,8.771-4.482,1.057-1.024,1.121-2.369,1.537-4.13,2.049.416,4.994.992,6.627,2.3.64,12.837-7.363,7.875-12.549,10.34,0,3.393.128,6.754-.032,10.084A.861.861,0,0,1,565.7,365.893Z",
    transform: "translate(-560.384 -342.3)",
    fill: "#2070b4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    transform: "translate(12.061 0.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M592.913,344.461a1.374,1.374,0,0,0-1.216-.1c-.544.352-.384,1.248-.9,1.633a15.9,15.9,0,0,1,7.907,6.242,3.686,3.686,0,0,0-.256-3.361,8.607,8.607,0,0,0-2.4-2.529A14.346,14.346,0,0,0,592.913,344.461Z",
    transform: "translate(-590.8 -344.255)",
    fill: "#22619c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    transform: "translate(3.673 1.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M582.047,347.46a6.891,6.891,0,0,0-1.665-.96c1.857,7.075-5.73,11.4-12.164,9.86.96,3.521,1.281,7.363-.64,10.564a3.356,3.356,0,0,1-2.977,1.089,1.068,1.068,0,0,0,.992.736h2.977a.889.889,0,0,0,.9-.864c.128-3.329.032-6.691.032-10.084C574.684,355.335,582.687,360.3,582.047,347.46Z",
    transform: "translate(-564.6 -346.5)",
    fill: "#22619c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1690",
    "data-name": "Group 1690",
    transform: "translate(14.708 10.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657",
    transform: "translate(0 16.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M590.9,344.113c.192-.288.224-1.024.416-1.313a7.581,7.581,0,0,1,4.418,2.273c1.248,1.152,2.3,2.465,3.649,3.521a1.3,1.3,0,0,1,.448.48c.224.448-.1.96-.384,1.345a22.279,22.279,0,0,0-3.425-3.3A16.238,16.238,0,0,0,590.9,344.113Z",
    transform: "translate(-590.9 -342.8)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1689",
    "data-name": "Group 1689",
    transform: "translate(0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(0 0.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M592.8,303.36a7.19,7.19,0,0,1-.864-2.529,6.039,6.039,0,0,1,1.12-3.617,4.448,4.448,0,0,1,4.418-4.514,20.478,20.478,0,0,1,3.681.352,4.111,4.111,0,0,1,4,3.969c.672,4.29-3.906,8.675-4.77,18.023a.349.349,0,0,1-.544.256c-2.625-1.921-5.794-6.082-8.739-6.4C591.8,308.034,592.444,305.889,592.8,303.36Z",
    transform: "translate(-591.1 -292.7)",
    fill: "#98a9d8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(0.864 0.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M606.989,297.393a4.837,4.837,0,0,0-.928-2.465,5.106,5.106,0,0,0-3.073-1.5c-.48-.1-.928-.16-1.409-.224-1.089,1.408-2.049,2.849-1.761,4.546.064,1.761.16,3.521.128,5.25l-3.041-.192a6.489,6.489,0,0,1-1.377-.192,2.034,2.034,0,0,1-1.12-.8c-.16-.288-.288-.64-.608-.672a6.39,6.39,0,0,0,1.44,3.041.575.575,0,0,0,.224.16c.224.032.32-.32.544-.448a.5.5,0,0,1,.512.1,2.415,2.415,0,0,0,.448.352c.384.192.864-.032,1.28.032.64.064,1.088.672,1.6,1.088a17.593,17.593,0,0,1-1.825,6.915,45.931,45.931,0,0,0,3.681,3.3.349.349,0,0,0,.544-.256C603.083,306.069,607.661,301.683,606.989,297.393Z",
    transform: "translate(-593.8 -293.2)",
    fill: "#7d95c9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665",
    transform: "translate(4.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M604.114,293.21a1.447,1.447,0,0,0-.224.9,2.829,2.829,0,0,0,.672,2.209,2.162,2.162,0,0,0,1.216.576,4.006,4.006,0,0,0,1.377-.1,6.449,6.449,0,0,0,3.169-1.729,1.131,1.131,0,0,0-.384-2.113,6.641,6.641,0,0,0-5.186-.192A1.464,1.464,0,0,0,604.114,293.21Z",
    transform: "translate(-603.886 -292.32)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1688",
    "data-name": "Group 1688",
    transform: "translate(1.569 5.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    transform: "translate(1.114 6.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M599.935,331.61a.279.279,0,0,0-.288-.128.258.258,0,0,0-.16.288.284.284,0,0,0,.32.192A.259.259,0,0,0,599.935,331.61Z",
    transform: "translate(-599.48 -331.474)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(1.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M599.652,311.174a.273.273,0,0,0,0-.416c-.128-.064-.352.032-.352.192C599.3,311.142,599.524,311.27,599.652,311.174Z",
    transform: "translate(-599.3 -310.737)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671",
    transform: "translate(4.078 1.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M608.791,316.116a.258.258,0,0,0,.416-.064.263.263,0,0,0-.224-.352C608.791,315.732,608.663,315.988,608.791,316.116Z",
    transform: "translate(-608.739 -315.7)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(2.31 10.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M603.4,341.99a.256.256,0,1,0,.32.256A.271.271,0,0,0,603.4,341.99Z",
    transform: "translate(-603.217 -341.985)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(6.43 9.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M616.346,339.642a.4.4,0,0,0,.128-.256.249.249,0,0,0-.064-.256c-.128-.1-.32.032-.32.192C616.058,339.45,616.186,339.578,616.346,339.642Z",
    transform: "translate(-616.085 -339.097)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677",
    transform: "translate(5.826 12.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1676",
    "data-name": "Group 1676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M614.712,350.456a.256.256,0,1,1-.256-.256A.275.275,0,0,1,614.712,350.456Z",
    transform: "translate(-614.2 -350.2)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1679",
    "data-name": "Group 1679",
    transform: "translate(4.354 7.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1678",
    "data-name": "Group 1678"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 0.256,
    cy: 0.256,
    r: 0.256,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681",
    transform: "translate(1.441 2.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 0.256,
    cy: 0.256,
    r: 0.256,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1683",
    "data-name": "Group 1683",
    transform: "translate(6.979 15.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1682",
    "data-name": "Group 1682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M618.248,358.424a.224.224,0,1,1-.224-.224A.219.219,0,0,1,618.248,358.424Z",
    transform: "translate(-617.8 -358.2)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1685",
    "data-name": "Group 1685",
    transform: "translate(3.361 12.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M606.884,349.592a.192.192,0,1,1-.192-.192C606.788,349.432,606.884,349.5,606.884,349.592Z",
    transform: "translate(-606.5 -349.4)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1687",
    "data-name": "Group 1687",
    transform: "translate(0 9.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M596.576,340.688a.288.288,0,1,1-.288-.288A.287.287,0,0,1,596.576,340.688Z",
    transform: "translate(-596 -340.4)",
    fill: "#e8e9eb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(17.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1692",
    "data-name": "Group 1692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1691",
    "data-name": "Group 1691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M605.386,260.5c-.544-.192-.9-.8-1.473-.8-.544.032-.864.64-1.344.864-.48.192-1.088.064-1.441.416-.416.384-.224,1.056-.384,1.6a3.565,3.565,0,0,1-.833,1.249,1.505,1.505,0,0,0-.416,1.376c.1.288.384.512.352.832a1.807,1.807,0,0,1-.128.384,1.883,1.883,0,0,0,.1,1.024,1.945,1.945,0,0,1,0,.96c0,.352-.32.64-.224,1.216,3.425.608,6.818,1.024,10.212.224a1.026,1.026,0,0,1-.1-1.088c.1-.192.288-.384.224-.576s-.352-.224-.48-.352c-.352-.384-.416-.864-.256-.992.288-.256.256-.7.256-1.056,0-.768-.736-1.312-1.12-1.985a8.366,8.366,0,0,1-.576-1.793,1.816,1.816,0,0,0-1.184-1.345C606.218,260.5,605.8,260.628,605.386,260.5Z",
    transform: "translate(-599.447 -259.7)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1694",
    "data-name": "Group 1694",
    transform: "translate(0.894 2.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1693",
    "data-name": "Group 1693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M603.22,267.165a1.178,1.178,0,0,0-.32.992c.064.224.256.416.288.64.032.512-.736.768-.8,1.312-.032.288.192.512.288.8a1.691,1.691,0,0,1-.064,1.12,6.173,6.173,0,0,0-.352,1.088.993.993,0,0,0,.9,1.281,12.828,12.828,0,0,0,3.3.48,7.042,7.042,0,0,0,3.233-.736.069.069,0,0,0,.064-.064c.064-.1-.064-.192-.16-.224a.792.792,0,0,1-.256-.736c.032-.288.16-.544.192-.8a.988.988,0,0,0-.128-.8c-.256-.32-.768-.256-1.12-.448a1.634,1.634,0,0,1-.736-1.216,2.591,2.591,0,0,0-.608-1.345c-.416-.352-1.056-.384-1.377-.832-.16-.256-.192-.576-.352-.832a1,1,0,0,0-1.056-.32A1.547,1.547,0,0,0,603.22,267.165Z",
    transform: "translate(-602.241 -266.489)",
    fill: "#d88568"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707",
    transform: "translate(1.936 6.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1697",
    "data-name": "Group 1697",
    transform: "translate(0 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1696",
    "data-name": "Group 1696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1695",
    "data-name": "Group 1695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M606.9,285.281a11.08,11.08,0,0,0,.736-3.681,6.6,6.6,0,0,0,2.625.192l.576,3.745a.772.772,0,0,1,.448.448,1.03,1.03,0,0,1-.224.768,4.737,4.737,0,0,1-2.081,1.889,2.756,2.756,0,0,1-2.721-.224,1.915,1.915,0,0,1-.48-2.529A3.812,3.812,0,0,1,606.9,285.281Z",
    transform: "translate(-605.494 -281.6)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(0.066 4.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M611.366,294.9a3.568,3.568,0,0,1-4.642,2.4,1.624,1.624,0,0,1-1.024-.8,2.117,2.117,0,0,0,.672.992,2.756,2.756,0,0,0,2.721.224,5.149,5.149,0,0,0,2.081-1.889.96.96,0,0,0,.224-.768A.141.141,0,0,0,611.366,294.9Z",
    transform: "translate(-605.7 -294.9)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(0.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M610.114,281.724a6.88,6.88,0,0,1-2.4-.224,11.956,11.956,0,0,1-.736,3.681,3.986,3.986,0,0,0-1.088.608,1.693,1.693,0,0,0-.288.96,11.518,11.518,0,0,1,3.649-1.472C610.082,285.021,609.922,283.229,610.114,281.724Z",
    transform: "translate(-605.6 -281.5)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706",
    transform: "translate(1.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M611,284.125a16.71,16.71,0,0,0,.384-2.625,5.952,5.952,0,0,0,2.241.224C613.561,283.325,612.409,283.9,611,284.125Z",
    transform: "translate(-611 -281.5)",
    fill: "#022a44"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(1.741 1.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(0 0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M605.21,268.175a.814.814,0,0,0,.1-.48,3.6,3.6,0,0,1,.224-1.28l.224-.64a3.819,3.819,0,0,1,4.194.576,2.549,2.549,0,0,1,.96,1.6,3.669,3.669,0,0,1-.448,1.825,5.473,5.473,0,0,1-1.121,1.793,4.073,4.073,0,0,1-1.793.864,6.782,6.782,0,0,1-1.409.128.856.856,0,0,1-.8-.576,6.811,6.811,0,0,1-.416-3.009A1.523,1.523,0,0,1,605.21,268.175Z",
    transform: "translate(-604.885 -265.385)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(1.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    "data-name": "Group 1714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M614.93,267.856a2.55,2.55,0,0,0-.961-1.6,3.806,3.806,0,0,0-3.169-.9,2.646,2.646,0,0,1,.384.256c.832.544.7,2.049,1.665,2.657a.965.965,0,0,1,.48.9,3.581,3.581,0,0,0,.384,1.921,7.484,7.484,0,0,0,.768-1.409A3.671,3.671,0,0,0,614.93,267.856Z",
    transform: "translate(-610.8 -265.292)",
    fill: "#d88568"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718",
    transform: "translate(3.154 1.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M614.838,270.074a10.561,10.561,0,0,0,.224-1.761,2.311,2.311,0,0,0-.416-1.216,1.4,1.4,0,0,0-.192-.224v-.192a3.109,3.109,0,0,0-.224-1.536,2.766,2.766,0,0,0-1.441-1.249,5.433,5.433,0,0,0-2.657-.448l-.832.384a2.222,2.222,0,0,1,1.6.544,5.025,5.025,0,0,1,.256.928,1.41,1.41,0,0,0,.768.832,1.46,1.46,0,0,1,.768.384c.16.224.064.544,0,.832a2.934,2.934,0,0,0-.1,1.185,2.031,2.031,0,0,0,.192.576,1.107,1.107,0,0,0,.416.608c.256.192.576.352.7.64.16.32.1.768.32,1.056a1.278,1.278,0,0,0,.96.352A2.355,2.355,0,0,1,614.838,270.074Z",
    transform: "translate(-609.3 -263.423)",
    fill: "#ffd255"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(0.203 1.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1720",
    "data-name": "Group 1720",
    transform: "translate(0 3.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M600.247,274.3c.1.1.192.16.224.288a.643.643,0,0,1-.128.416.831.831,0,0,0,.192.928,1.25,1.25,0,0,1,.032-.96c.1-.16.224-.352.16-.512-.032-.256-.352-.384-.448-.608a.654.654,0,0,1,.1-.544,1.542,1.542,0,0,0,.256-.512,2.087,2.087,0,0,0-.512.672A.965.965,0,0,0,600.247,274.3Z",
    transform: "translate(-600.08 -272.8)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722",
    transform: "translate(0.371 6.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M601.676,284.1a3.143,3.143,0,0,0-.416,1.024,1.122,1.122,0,0,0,.32,1.024A3.207,3.207,0,0,1,601.676,284.1Z",
    transform: "translate(-601.241 -284.1)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733",
    transform: "translate(2.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724",
    transform: "translate(4.29 2.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M621.8,271.5a.6.6,0,0,1,.384.608,3.382,3.382,0,0,1-.192.768,1.056,1.056,0,0,0,.032.768,1.441,1.441,0,0,0,.608.448.658.658,0,0,1,.384.608c-.032.192-.192.32-.192.512a.557.557,0,0,0,.192.352c.1.1.224.16.288.288a.545.545,0,0,1,.064.448,2.5,2.5,0,0,1-.16.448.743.743,0,0,0,.128-1.056c-.064-.1-.16-.16-.224-.256a.722.722,0,0,1,.064-.512.94.94,0,0,0,.128-.512c-.032-.224-.256-.352-.48-.48-.192-.1-.448-.224-.512-.448-.1-.256.064-.512.128-.8A.979.979,0,0,0,621.8,271.5Z",
    transform: "translate(-621.8 -271.5)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726",
    transform: "translate(6.21 4.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M628.28,278.12c.1-.224.288-.416.256-.64s-.256-.384-.448-.48a1.769,1.769,0,0,1,.256.192c.064.1.128.192.1.288-.032.16-.16.256-.288.384a1.134,1.134,0,0,0-.192,1.216,5.575,5.575,0,0,1,.352.576,1.1,1.1,0,0,1-.032.9,3.111,3.111,0,0,1-.48.768,3.267,3.267,0,0,0,.576-.576,1.179,1.179,0,0,0,.224-.8,4.325,4.325,0,0,0-.416-.864A1.267,1.267,0,0,1,628.28,278.12Z",
    transform: "translate(-627.8 -277)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1728",
    "data-name": "Group 1728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1727",
    "data-name": "Group 1727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M609.617,262.957a2.284,2.284,0,0,1,1.056.7,2.23,2.23,0,0,0-2.273-.128A1.162,1.162,0,0,1,609.617,262.957Z",
    transform: "translate(-608.4 -262.937)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730",
    transform: "translate(2.017 0.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1729",
    "data-name": "Group 1729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M615.981,265a2.146,2.146,0,0,1-.352-.576,2.148,2.148,0,0,0-.352-.576.736.736,0,0,0-.576-.256.874.874,0,0,1,.448.448c.1.192.192.416.288.576A1.013,1.013,0,0,0,615.981,265Z",
    transform: "translate(-614.7 -263.585)",
    fill: "#faa701"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1732",
    "data-name": "Group 1732",
    transform: "translate(3.265 0.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M618.6,265.2a.651.651,0,0,0,.48.544.612.612,0,0,0-.224-.448C618.728,265.2,618.76,265.2,618.6,265.2Z",
    transform: "translate(-618.6 -265.2)",
    fill: "#faa701"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1784",
    "data-name": "Group 1784",
    transform: "translate(21.922 12.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(3.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(0.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1738",
    "data-name": "Group 1738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1736",
    "data-name": "Group 1736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M626.909,312.775l-3.105.416a37.264,37.264,0,0,0-.448-8.227c-.32-2.049-.8-4.226-.032-6.146a2.19,2.19,0,0,1,1.665-1.537,1.805,1.805,0,0,1,1.441.608,3.844,3.844,0,0,1,.8,1.409c.992,2.657.768,4.674.512,7.491A25.915,25.915,0,0,1,626.909,312.775Z",
    transform: "translate(-622.91 -297.272)",
    fill: "#98a9d8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    "data-name": "Group 1743",
    transform: "translate(0 2.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    "data-name": "Group 1742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    "data-name": "Group 1741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M623.089,303.7c-.512,1.793-.1,3.745.224,5.634a39.322,39.322,0,0,1,.448,8.227l.864-.128A37,37,0,0,0,623.089,303.7Z",
    transform: "translate(-622.848 -303.7)",
    fill: "#7d95c9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745",
    transform: "translate(1.393 1.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1744",
    "data-name": "Group 1744"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 0.192,
    cy: 0.192,
    r: 0.192,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(3.538 3.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 0.32,
    cy: 0.32,
    r: 0.32,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(1.905 6.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M629.312,318.856a.256.256,0,1,1-.256-.256A.253.253,0,0,1,629.312,318.856Z",
    transform: "translate(-628.8 -318.6)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751",
    transform: "translate(4.146 6.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    "data-name": "Group 1750"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 0.256,
    cy: 0.256,
    r: 0.256,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(3.378 10.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M633.848,330.824a.224.224,0,1,1-.224-.224A.219.219,0,0,1,633.848,330.824Z",
    transform: "translate(-633.4 -330.6)",
    fill: "#e8e9eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1783",
    "data-name": "Group 1783",
    transform: "translate(0 1.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    "data-name": "Group 1774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758",
    transform: "translate(0.013 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M616.716,306.9c-.128.16-.416.32-.448.512-.032.064.032.1.032.16a5.319,5.319,0,0,0,.064.992,3.846,3.846,0,0,1-1.7.768l-.064-.608a.99.99,0,0,0-.192-.416c-.064-.128-.192-.192-.288-.288a1.386,1.386,0,0,1-.352-.832,8.989,8.989,0,0,1,0-.928,25.506,25.506,0,0,0-.288-2.689c0-.128-.032-.256.032-.352a.408.408,0,0,1,.288.224,14.445,14.445,0,0,1,.416,1.761c.128-.16.064-.352.032-.576a5.321,5.321,0,0,0-.1-.7,5.341,5.341,0,0,1-.16-.992.431.431,0,0,1,.16-.288c.1-.032.16.032.192.16a.667.667,0,0,1,0-.256.16.16,0,0,1,.192-.16,3.823,3.823,0,0,1,.736,1.376,3.484,3.484,0,0,1,.064,1.185,2.4,2.4,0,0,0-.1-1.345,3.428,3.428,0,0,1-.224-.608.677.677,0,0,1,.064-.608,4.182,4.182,0,0,1,.992,2.433,3.1,3.1,0,0,0,0,1.088,1.3,1.3,0,0,0,.448-.384c.1-.16.128-.32.224-.48a.622.622,0,0,1,.384-.32.193.193,0,0,1,.128.032.239.239,0,0,1,.032.16c-.1.448-.352.832-.416,1.281C616.844,306.42,616.876,306.708,616.716,306.9Z",
    transform: "translate(-613.475 -302.38)",
    fill: "#e7a988"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1766",
    "data-name": "Group 1766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760",
    transform: "translate(0.501 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M615,318.384a.97.97,0,0,0,.16.224,2.463,2.463,0,0,1,.288.288,2.425,2.425,0,0,1,.192.416l.064.608a3.846,3.846,0,0,0,1.7-.768,9.634,9.634,0,0,1-.064-.992c0-.064-.064-.1-.032-.16A4.4,4.4,0,0,1,615,318.384Z",
    transform: "translate(-615 -318)",
    fill: "#d88568"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M616.689,306.9a1.629,1.629,0,0,0,.16-.7c.064-.448.32-.832.416-1.28a.289.289,0,0,0-.032-.16c-.032-.032-.064-.032-.128-.032a.486.486,0,0,0-.384.32c-.1.16-.128.32-.224.48a1.688,1.688,0,0,1-.448.384,4.118,4.118,0,0,1,0-1.088,4.405,4.405,0,0,0-.993-2.433.678.678,0,0,0-.064.608c.064.192.16.384.224.608a2.4,2.4,0,0,1,.1,1.344,3.49,3.49,0,0,0-.064-1.184,3.826,3.826,0,0,0-.736-1.376.16.16,0,0,0-.192.16.663.663,0,0,0,0,.256c-.032-.1-.064-.192-.192-.16a.52.52,0,0,0-.16.288,3.572,3.572,0,0,0,.16.992,4.677,4.677,0,0,1,.1.7c0,.224.1.384-.032.576a7.927,7.927,0,0,0-.416-1.761c-.032-.1-.16-.256-.288-.224a.441.441,0,0,0-.032.352,25.51,25.51,0,0,1,.288,2.689,8.989,8.989,0,0,0,0,.928,2.127,2.127,0,0,0,.192.64,4.431,4.431,0,0,0,2.3-.352h0C616.3,307.189,616.593,307.06,616.689,306.9Z",
    transform: "translate(-613.434 -302.38)",
    fill: "#e7a988"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764",
    transform: "translate(0.725 0.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M616.468,305.565h-.16a4.75,4.75,0,0,0-.608-2.369l.128-.1A5.144,5.144,0,0,1,616.468,305.565Z",
    transform: "translate(-615.7 -303.1)",
    fill: "#022a44"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1771",
    "data-name": "Group 1771",
    transform: "translate(0.853 4.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    "data-name": "Group 1770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1767",
    "data-name": "Group 1767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M620.966,327.872a2.144,2.144,0,0,1-2.017-.7,6.55,6.55,0,0,1-1.056-2.113c-.608-2.113-1.184-4.29-1.793-6.4a3.046,3.046,0,0,0,2.273-1.152,29.237,29.237,0,0,0,2.529,4.994,7.9,7.9,0,0,1,1.5,2.849C622.567,326.4,622.022,327.712,620.966,327.872Z",
    transform: "translate(-616.1 -317.5)",
    fill: "#98a9d8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773",
    transform: "translate(3.03 4.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M626.1,325.067a7.7,7.7,0,0,0-1.344-3.841c-.192-.32-.384-.608-.576-.9a8.754,8.754,0,0,1-1.28-2.5l.16-.032a9.17,9.17,0,0,0,1.249,2.433c.192.288.384.576.576.928a8.18,8.18,0,0,1,1.377,3.938Z",
    transform: "translate(-622.9 -317.8)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776",
    transform: "translate(4.119 12.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 0.256,
    cy: 0.256,
    r: 0.256,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778",
    transform: "translate(4.663 9.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 0.192,
    cy: 0.192,
    r: 0.192,
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1780",
    "data-name": "Group 1780",
    transform: "translate(2.454 8.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M621.484,329.592a.192.192,0,1,1-.192-.192Q621.484,329.448,621.484,329.592Z",
    transform: "translate(-621.1 -329.4)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782",
    transform: "translate(2.87 6.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1781",
    "data-name": "Group 1781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M622.784,323.792a.192.192,0,1,1-.192-.192A.206.206,0,0,1,622.784,323.792Z",
    transform: "translate(-622.4 -323.6)",
    fill: "#e8e9eb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788",
    transform: "translate(4.84 30.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    "data-name": "Group 1786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1785",
    "data-name": "Group 1785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M562.516,374.555a1.113,1.113,0,0,1-1.12-.992l-1.152-8.675a6.288,6.288,0,0,1,.192-3.617,5.119,5.119,0,0,1,1.5-1.889A19.139,19.139,0,0,1,566.1,357.4a13.968,13.968,0,0,0,4.642-2.5l.1.128a13.872,13.872,0,0,1-4.674,2.529,19.619,19.619,0,0,0-4.13,1.985A5.189,5.189,0,0,0,560.6,361.4a5.937,5.937,0,0,0-.192,3.521l.032.224,1.12,8.419a.966.966,0,0,0,.96.832Z",
    transform: "translate(-560.075 -354.9)",
    fill: "#022a44"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1881",
    "data-name": "Group 1881",
    transform: "translate(63.032 61.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1878",
    "data-name": "Group 1878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(12.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1792",
    "data-name": "Group 1792",
    transform: "translate(3.262 2.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1791",
    "data-name": "Group 1791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1790",
    "data-name": "Group 1790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M313.844,236.262a3.152,3.152,0,0,1-.576,2.337,4.156,4.156,0,0,1-3.041,3.169,3.887,3.887,0,0,1,.384-7.2,2.366,2.366,0,0,1,2.337.48Z",
    transform: "translate(-307.979 -234.455)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1795",
    "data-name": "Group 1795",
    transform: "translate(3.262 2.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    "data-name": "Group 1794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1793",
    "data-name": "Group 1793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M311.539,234.5a2.96,2.96,0,0,0-.928.128,3.839,3.839,0,0,0-2.625,3.457,3.943,3.943,0,0,0,2.241,3.745,2.073,2.073,0,0,0,.416-.128C310.131,239.206,310.1,236.517,311.539,234.5Z",
    transform: "translate(-307.979 -234.5)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    "data-name": "Group 1798",
    transform: "translate(0 4.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    "data-name": "Group 1797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    "data-name": "Group 1796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M297.857,248.33c-.16-.192,0-.448.128-.64a11.226,11.226,0,0,0,2.241-5.09,14.84,14.84,0,0,0,3.553.9,41.48,41.48,0,0,0-1.089,6.274c-1.536-.448-3.041-.864-4.578-1.312A.644.644,0,0,1,297.857,248.33Z",
    transform: "translate(-297.79 -242.6)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M312.032,231.6a2.051,2.051,0,0,0,1.344-1.537,2.044,2.044,0,0,1-1.5.192.53.53,0,0,0,.384-.16,3.122,3.122,0,0,1-1.633-.7c-.48-.352-.928-.768-1.409-1.088a2.529,2.529,0,0,0-1.7-.448.817.817,0,0,0-.224.064,2.73,2.73,0,0,0-1.024.064,3.255,3.255,0,0,0-2.209,2.529,7.817,7.817,0,0,0-.064,3.649,6.41,6.41,0,0,0,4.1.16c.16-.064.352-.128.512-.192a5.423,5.423,0,0,0,.128-.7,1.372,1.372,0,0,1,.32-.768.632.632,0,0,1,.768-.128.539.539,0,0,1,.224.48.707.707,0,0,1-.032.256,4.442,4.442,0,0,0,.672-.672,2.379,2.379,0,0,0,2.145-1.056A3.375,3.375,0,0,1,312.032,231.6Z",
    transform: "translate(-301.881 -227.83)",
    fill: "#352f6c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1800",
    "data-name": "Group 1800",
    transform: "translate(7.097 4.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1799",
    "data-name": "Group 1799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M320.485,243.819a.319.319,0,0,1,.16-.128.419.419,0,0,0,.128-.416.327.327,0,0,0-.384-.192.444.444,0,0,0-.224.384,2.549,2.549,0,0,0,.1.48.155.155,0,0,0-.224,0,.2.2,0,0,0-.064.224.441.441,0,0,0,.1.128.141.141,0,0,1,.032.16c0,.032-.032.064-.064.1s0,.064.032.1c.032,0,.032,0,.064-.032a.69.69,0,0,0,.288-.448C320.421,244.011,320.421,243.883,320.485,243.819Z",
    transform: "translate(-319.961 -243.075)",
    fill: "#d88568"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802",
    transform: "translate(6.021 0.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M317.624,230.96c.128.1.128.288.224.416.128.128.352.1.544.1a1.461,1.461,0,0,1,.928.416,3.974,3.974,0,0,1,.608.832,5.558,5.558,0,0,0,.352-.576c-1.216-.7-2.465-1.441-3.681-2.145.064.288.128.608.192.9a.245.245,0,0,0,.064.16.3.3,0,0,0,.384-.032C317.336,230.992,317.5,230.9,317.624,230.96Z",
    transform: "translate(-316.6 -230)",
    fill: "#2070b4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    transform: "translate(0.278 29.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(0 35.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M265.2,433.381a3.007,3.007,0,0,0-1.056-.256,2.271,2.271,0,0,1-.9-.288.731.731,0,0,1-.416-.8,5.472,5.472,0,0,1-2.209-.736,5.789,5.789,0,0,1-.576,1.729,2.271,2.271,0,0,0-.032.48,2.48,2.48,0,0,0,.064,1.184,3.624,3.624,0,0,0,2.3.448l.1-.384a2.714,2.714,0,0,1,1.12-.1,3.282,3.282,0,0,0,.832.128,2.14,2.14,0,0,0,.576-.224,1.063,1.063,0,0,0,.544-.576C265.645,433.669,265.485,433.541,265.2,433.381Z",
    transform: "translate(-259.969 -431.3)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1807",
    "data-name": "Group 1807",
    transform: "translate(0.535 35.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M263.8,433.636a9.928,9.928,0,0,0-1.921-.736,1.728,1.728,0,0,0-.224.416.545.545,0,0,0,.064.448.594.594,0,0,0,.384.224A1.916,1.916,0,0,0,263.8,433.636Z",
    transform: "translate(-261.64 -432.9)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810",
    transform: "translate(0.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M261.76,349.727c-.32.768-.736,3.585-1.12,4.61-.32.768-.64,1.184-.16,1.889a2.927,2.927,0,0,0,2.721,1.12c2.145-5.506,4.674-10.884,6.658-16.454s3.457-11.428,3.329-17.35c-3.2-1.024-6.4-2.017-9.6-3.041-3.009,7.171-1.024,9.315-.736,14.565C263.137,340.283,263.681,344.829,261.76,349.727Z",
    transform: "translate(-260.235 -320.5)",
    fill: "#2070b4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(1.931 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M277.108,325.241c-2.337-.736-4.706-1.5-7.043-2.241-3.2,7.139-.256,15.142-.864,22.536a49.933,49.933,0,0,1-3.2,13.477,1.789,1.789,0,0,0,1.152.032c2.145-5.506,4.674-10.884,6.659-16.454C275.764,336.989,277.236,331.131,277.108,325.241Z",
    transform: "translate(-266 -323)",
    fill: "#22619c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(4.069 0.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M274.35,322.8c2.433.768,4.866,1.536,7.267,2.3.128,5.922-1.344,11.781-3.329,17.351-1.313,3.649-2.817,7.171-4.322,10.756.256-1.312.384-2.657.576-3.905C276.495,340.15,269.676,331.443,274.35,322.8Z",
    transform: "translate(-272.678 -322.8)",
    fill: "#022a44"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1831",
    "data-name": "Group 1831",
    transform: "translate(3.796 28.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819",
    transform: "translate(4.922 40.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M292.98,445.565a1.2,1.2,0,0,0-.928-.608,6.926,6.926,0,0,0-1.152,0c-1.537,0-3.009-.768-4.514-.544,0,.64-.1,1.313-.032,1.953a1.361,1.361,0,0,0,.064.352,5.256,5.256,0,0,0,.128.992,1.216,1.216,0,0,0,.16.48.942.942,0,0,0,.576.32,2.971,2.971,0,0,0,2.433-.416.748.748,0,0,0,.224-.224.474.474,0,0,0,.032-.224,4.58,4.58,0,0,1,.7-.256,6.186,6.186,0,0,0,1.281-.48C292.468,446.686,293.2,446.11,292.98,445.565Z",
    transform: "translate(-286.331 -444.372)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821",
    transform: "translate(5.015 40.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M290.265,445.6a.249.249,0,0,1,.288.192.381.381,0,0,1-.128.352.711.711,0,0,1-.352.16,6.006,6.006,0,0,1-1.7.192,2.751,2.751,0,0,1-1.024-.16,1.179,1.179,0,0,1-.7-.7.7.7,0,0,1,.416-.832Z",
    transform: "translate(-286.622 -444.8)",
    fill: "#e8e9eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1824",
    "data-name": "Group 1824",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M271.452,320.045l.192-2.145a39.73,39.73,0,0,0,9.6,3.329c0,7.075.672,13.061.48,19.559-.192,6.018-1.248,12.485-2.113,18.823a3.862,3.862,0,0,1-3.746-.512c-.064-5.346-.384-9.508-.064-11.877.32-2.337-.8-8.163-1.5-10.436C272.06,329.584,269.979,328.5,271.452,320.045Z",
    transform: "translate(-270.958 -317.9)",
    fill: "#2070b4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M277.981,339.828c-.576-6.466-3.617-13.477-1.857-20.039-1.537-.576-3.073-1.249-4.482-1.889l-.192,2.145c-1.473,8.451.608,9.54,2.817,16.71.7,2.3,1.825,8.1,1.5,10.436-.32,2.369,0,6.531.064,11.877a3.5,3.5,0,0,0,1.729.736A122.333,122.333,0,0,0,277.981,339.828Z",
    transform: "translate(-270.957 -317.9)",
    fill: "#22619c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1830",
    "data-name": "Group 1830",
    transform: "translate(7.889 5.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1829",
    "data-name": "Group 1829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M295.6,370.878c2.4-11.908,1.569-24.361.448-36.046l.256-.032c.9,11.877,1.825,24.137-.512,36.014C295.7,370.846,295.7,370.878,295.6,370.878Z",
    transform: "translate(-295.6 -334.8)",
    fill: "#27b2e4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833",
    transform: "translate(7.427 9.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1832",
    "data-name": "Group 1832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M285.181,258.541a2.541,2.541,0,0,0-2.593,1.665,5.77,5.77,0,0,0-.1,3.3,22.347,22.347,0,0,0,3.649,8.451,14.131,14.131,0,0,0,2.4,2.753c2.4,1.953,5.6,2.465,8.643,2.913.288-.672.608-1.312.9-1.985a19.136,19.136,0,0,1-8.035-8.291,38.484,38.484,0,0,1-2.529-7.747Z",
    transform: "translate(-282.3 -258.513)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835",
    transform: "translate(20.872 21.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    "data-name": "Group 1834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M330.414,306.444H324.3l2.5-10.244h6.146Z",
    transform: "translate(-324.3 -296.2)",
    fill: "#022a44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837",
    transform: "translate(21.544 21.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M331.586,304.843H326.4l2.113-8.643H333.7Z",
    transform: "translate(-326.4 -296.2)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(21.704 21.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M328.853,296.2l-1.953,7.971c1.665-1.953,3.553-3.393,6.018-3.457l1.12-4.514Z",
    transform: "translate(-326.9 -296.2)",
    fill: "#c7d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856",
    transform: "translate(0 7.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    "data-name": "Group 1841",
    transform: "translate(10.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M292.7,254.325a3.8,3.8,0,0,0,1.569-1.825,7.427,7.427,0,0,1,6.018,3.873l-3.073-1.152a10.941,10.941,0,0,0-4-.96Z",
    transform: "translate(-292.7 -252.5)",
    fill: "#352f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1845",
    "data-name": "Group 1845",
    transform: "translate(0 1.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    "data-name": "Group 1844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M274.338,283.968c.1-1.024-.32-3.233-.16-6.659a9.6,9.6,0,0,1,.256-2.561c.16-2.081.832-2.753,1.857-4.578.768-1.377,1.985-3.714,2.785-5.058s1.248-3.137.416-4.514a5.447,5.447,0,0,0-2.241-1.825,26.726,26.726,0,0,0-3.969-1.665c-1.537-.512-3.329-.864-4.674.064a9.641,9.641,0,0,0-2.5,2.721c-3.041,5.058-2.625,6.915-4.194,15.654-.128.7-2.465,5.7-2.817,7.267a19.764,19.764,0,0,0,2.337.736,25.89,25.89,0,0,1,1.729-5.986c0,2.369-.672,4-.544,6.274A35.048,35.048,0,0,0,274.338,283.968Z",
    transform: "translate(-259.1 -256.596)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1847",
    "data-name": "Group 1847",
    transform: "translate(11.126 1.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    "data-name": "Group 1846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M294.19,257.612a20.873,20.873,0,0,1,5.058,1.024,9.111,9.111,0,0,0-4.866-1.537.812.812,0,0,0-.384.064.234.234,0,0,0-.1.352A.447.447,0,0,0,294.19,257.612Z",
    transform: "translate(-293.856 -257.1)",
    fill: "#292666"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    "data-name": "Group 1849",
    transform: "translate(8.099 1.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M286.865,257.7a4.278,4.278,0,0,0-2.465,2.017C285.232,259.045,286.065,258.372,286.865,257.7Z",
    transform: "translate(-284.4 -257.7)",
    fill: "#22619c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851",
    transform: "translate(17.447 4.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M314.976,267.8c-.448.64-.928,1.248-1.376,1.889A2.786,2.786,0,0,1,314.976,267.8Z",
    transform: "translate(-313.6 -267.8)",
    fill: "#22619c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    "data-name": "Group 1855",
    transform: "translate(12.804 5.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M299.483,293.373c.672-.064,1.376-.128,2.049-.224.1-1.024-.32-3.233-.16-6.658a9.609,9.609,0,0,1,.256-2.561c.16-2.081.832-2.753,1.857-4.578.768-1.376,1.985-3.713,2.785-5.058a4.607,4.607,0,0,0,.576-4.194C298.523,274.55,298.619,284.345,299.483,293.373Z",
    transform: "translate(-299.098 -270.1)",
    fill: "#292666"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876",
    transform: "translate(17.004 8.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858",
    transform: "translate(4.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    "data-name": "Group 1857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M328.816,259.908a6.41,6.41,0,0,1,1.537-.608,3.571,3.571,0,0,1-.352-1.729,1.2,1.2,0,0,0-.16-.96.937.937,0,0,0-.512-.224c-.416-.1-.864-.224-1.28-.32s-.544.032-.768-.352c-.1-.16-.48-.576-.576-.7s-.384-.7-.672-.448c-.128.128.16.672.224.832.192.416.352.832.544,1.248.128.32.224.544-.032.8-.1.1-.32.1-.416.16s-.064.448-.032.576a.386.386,0,0,0,.16.16C327.248,258.852,328.048,259.364,328.816,259.908Z",
    transform: "translate(-325.999 -254.497)",
    fill: "#e7a988"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(6.557 3.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M335.357,267.723c-.16-.32-.32-.608-.512-.928a2.834,2.834,0,0,0-1.985.736.382.382,0,0,0-.16.288.244.244,0,0,0,.064.16c.224.416.416.832.64,1.249a3.475,3.475,0,0,1,2.081-1.152Z",
    transform: "translate(-332.7 -266.792)",
    fill: "#98a9d8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864",
    transform: "translate(6.697 4.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M338.313,281.273a1.934,1.934,0,0,0,1.12-1.312,5.4,5.4,0,0,0-.128-3.329c-.352-1.056-.9-2.081-1.345-3.105-.608-1.409-.992-2.913-1.7-4.29a1.812,1.812,0,0,0-.608-.768,2.673,2.673,0,0,0-1.312.1c-.32.032-.608.384-.928.512a.479.479,0,0,0-.256.576,42.5,42.5,0,0,1,1.152,6.018,13.738,13.738,0,0,0,.608,3.233,3.8,3.8,0,0,0,2.209,2.337A1.679,1.679,0,0,0,338.313,281.273Z",
    transform: "translate(-333.139 -268.406)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    "data-name": "Group 1867",
    transform: "translate(6.697 4.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1866",
    "data-name": "Group 1866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M333.415,269.784a.479.479,0,0,0-.256.576,42.5,42.5,0,0,1,1.152,6.018,13.739,13.739,0,0,0,.608,3.233,3.8,3.8,0,0,0,2.209,2.337h.064a37.735,37.735,0,0,0-3.169-12.549A4.644,4.644,0,0,1,333.415,269.784Z",
    transform: "translate(-333.139 -269.4)",
    fill: "#292666"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    transform: "translate(0.001 4.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M312.278,271.439a5.579,5.579,0,0,1,2.273-3.681,1.1,1.1,0,0,1,.864-.288,1.329,1.329,0,0,1,.64.384c2.3,2.209,4.034,4.962,6.338,7.139a14.28,14.28,0,0,1,1.825,1.857,3.6,3.6,0,0,1,.8,2.433,2.046,2.046,0,0,1-1.6,1.825,2.849,2.849,0,0,1-1.857-.64,26.927,26.927,0,0,1-2.753-2.3,32.489,32.489,0,0,0-4.706-3.393,4.368,4.368,0,0,1-1.409-1.12A2.8,2.8,0,0,1,312.278,271.439Z",
    transform: "translate(-312.22 -267.455)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872",
    transform: "translate(10.718 12.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M345.7,292.6a4.187,4.187,0,0,1,1.44,3.233,2.738,2.738,0,0,0-.1-1.889A2.514,2.514,0,0,0,345.7,292.6Z",
    transform: "translate(-345.7 -292.6)",
    fill: "#22619c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1875",
    "data-name": "Group 1875",
    transform: "translate(0 7.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1874",
    "data-name": "Group 1874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M322.68,288.227c-2.689-4.034-7.427-5.57-10.372-9.027,0,.064-.032.16-.032.224a3.033,3.033,0,0,0,.384,2.241,4.843,4.843,0,0,0,1.409,1.12,32.5,32.5,0,0,1,4.706,3.393c.9.768,1.761,1.6,2.753,2.3a2.847,2.847,0,0,0,1.665.64A8.148,8.148,0,0,0,322.68,288.227Z",
    transform: "translate(-312.218 -279.2)",
    fill: "#292666"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1880",
    "data-name": "Group 1880",
    transform: "translate(4.226 12.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M272.3,283.114a37.416,37.416,0,0,1,4.738-16.614A32.991,32.991,0,0,0,272.3,283.114Z",
    transform: "translate(-272.3 -266.5)",
    fill: "#292666"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    transform: "translate(109.217 52.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1935",
    "data-name": "Group 1935",
    transform: "translate(1.829 32.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1918",
    "data-name": "Group 1918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899",
    transform: "translate(8.611 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888",
    transform: "translate(9.581 42.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1883",
    "data-name": "Group 1883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1882",
    "data-name": "Group 1882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M466.073,432.656c-.448.96.224,1.793.224,2.657.928.064,1.665.032,2.593.064v-.608a8.527,8.527,0,0,0,5.634.416,1.093,1.093,0,0,0-.7-1.057,4.55,4.55,0,0,0-1.312-.256,5.05,5.05,0,0,1-1.921-.64A2.776,2.776,0,0,1,469.4,431.6c-.864.1-1.7.16-2.561.256a.939.939,0,0,0-.608.224C466.073,432.208,466.137,432.464,466.073,432.656Z",
    transform: "translate(-465.919 -431.6)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887",
    transform: "translate(0.41 0.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M467.872,433.888a5.107,5.107,0,0,0,2.081.16.348.348,0,0,0,.288-.128.352.352,0,0,0,0-.256c-.064-.288-.1-.576-.16-.864a23.281,23.281,0,0,0-2.881.64A.986.986,0,0,0,467.872,433.888Z",
    transform: "translate(-467.2 -432.8)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    "data-name": "Group 1891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1889",
    "data-name": "Group 1889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M435.992,298.2A39.2,39.2,0,0,0,437.3,307c2.529,12,5.218,23.337,8,35.533,1.024-.352,3.137-.736,4.162-1.088a376.525,376.525,0,0,0-4.994-43.248Z",
    transform: "translate(-435.989 -298.2)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1894",
    "data-name": "Group 1894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1893",
    "data-name": "Group 1893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1892",
    "data-name": "Group 1892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M435.992,298.2A39.2,39.2,0,0,0,437.3,307c2.529,12,5.218,23.337,8,35.533.544-.192,1.376-.384,2.209-.576-2.241-14.982-6.4-29.387-11.236-43.76Z",
    transform: "translate(-435.989 -298.2)",
    fill: "#292666"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897",
    transform: "translate(2.661 8.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M451.823,360.981c-.448-2.177-.864-4.066-1.28-6.114-2.017-10.02-3.713-18.6-6.242-28.971l.1-.1c2.529,10.372,4.29,19.015,6.306,29.035.416,2.081.768,3.938,1.216,6.114Z",
    transform: "translate(-444.3 -325.8)",
    fill: "#7d95c9"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1917",
    "data-name": "Group 1917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    "data-name": "Group 1906",
    transform: "translate(0 44.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1902",
    "data-name": "Group 1902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1900",
    "data-name": "Group 1900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M414.47,441.929c.32-.224.32-.672.32-1.056-.032-.544-.064-1.088-.1-1.6a.834.834,0,0,0-.128-.48.779.779,0,0,0-.608-.192c-1.024,0-2.081,0-3.105.032-.544,1.377-1.088,2.785-1.633,4.162-.1.288-.224.608-.032.832a1.939,1.939,0,0,0,.864.384,16.7,16.7,0,0,0,1.793.032,3,3,0,0,0,1.537-.736c.256-.384-.064-.7.256-1.024C413.862,442.025,414.214,442.089,414.47,441.929Z",
    transform: "translate(-409.089 -438.6)",
    fill: "#022a44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1905",
    "data-name": "Group 1905",
    transform: "translate(1.631 0.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1904",
    "data-name": "Group 1904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M414.99,440.922c.288.032.544.032.832.064a2.961,2.961,0,0,0,1.184-.064,1.187,1.187,0,0,0,.864-.736,6.812,6.812,0,0,0-2.881-.352,1.506,1.506,0,0,0-.544.128.5.5,0,0,0-.256.48.552.552,0,0,0,.32.384A1.068,1.068,0,0,0,414.99,440.922Z",
    transform: "translate(-414.185 -439.802)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1916",
    "data-name": "Group 1916",
    transform: "translate(0.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1909",
    "data-name": "Group 1909",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1908",
    "data-name": "Group 1908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    "data-name": "Group 1907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M414.465,298.2l-.1,1.056c-.96,9.059-1.793,14.982-1.825,22.44-.064,7.459.256,14.95-.544,22.376a17.384,17.384,0,0,1,5.154.224c1.184-14.085,3.745-26.186,5.954-39.183a28.046,28.046,0,0,0-.1-6.915Z",
    transform: "translate(-412 -298.2)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1912",
    "data-name": "Group 1912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    "data-name": "Group 1911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    "data-name": "Group 1910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M416.29,310.109c2.017-5.474,4.642-.576,6.37-11.909h-8.2l-.1,1.056c-.96,9.059-1.793,14.982-1.825,22.44-.064,7.459.256,14.95-.544,22.376l1.344-.1C413.217,334.118,412.832,319.36,416.29,310.109Z",
    transform: "translate(-412 -298.2)",
    fill: "#292666"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1915",
    "data-name": "Group 1915",
    transform: "translate(4.162 8.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1913",
    "data-name": "Group 1913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M425.128,361.078l-.128-.064c1.024-12.869,3.233-24.329,6.242-37.614l.128.064C428.361,336.749,426.152,348.241,425.128,361.078Z",
    transform: "translate(-425 -323.4)",
    fill: "#7d95c9"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1934",
    "data-name": "Group 1934",
    transform: "translate(3.685 1.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1921",
    "data-name": "Group 1921",
    transform: "translate(0 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1920",
    "data-name": "Group 1920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1919",
    "data-name": "Group 1919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M426.618,305.328V304.4c-1.857.064-3.681.192-5.538.384l-.48,1.537a53.783,53.783,0,0,1,6.05-.64A1.2,1.2,0,0,0,426.618,305.328Z",
    transform: "translate(-420.6 -304.4)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1924",
    "data-name": "Group 1924",
    transform: "translate(6.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1923",
    "data-name": "Group 1923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1922",
    "data-name": "Group 1922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M440.6,304.164c.032.32,0,.64.032.928v.32c.192,0,.416-.032.608-.032V304.1A2.074,2.074,0,0,1,440.6,304.164Z",
    transform: "translate(-440.6 -304.1)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1927",
    "data-name": "Group 1927",
    transform: "translate(11.108 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1925",
    "data-name": "Group 1925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M455.332,305.412c.8.032,1.569.064,2.337.128-.1-.48-.16-.928-.256-1.409-.7-.032-1.409-.032-2.113-.032C455.3,304.548,455.3,305,455.332,305.412Z",
    transform: "translate(-455.3 -304.1)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1930",
    "data-name": "Group 1930",
    transform: "translate(9.988 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1929",
    "data-name": "Group 1929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1928",
    "data-name": "Group 1928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M452.568,305.412c0-.448,0-.864-.032-1.312H451.8a5.752,5.752,0,0,1,.1,1.281A4.729,4.729,0,0,0,452.568,305.412Z",
    transform: "translate(-451.8 -304.1)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    transform: "translate(7.427 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1932",
    "data-name": "Group 1932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1931",
    "data-name": "Group 1931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M445.945,304.1c-.7,0-1.441,0-2.145.032v1.28c.768-.032,1.5-.032,2.273,0A3.6,3.6,0,0,0,445.945,304.1Z",
    transform: "translate(-443.8 -304.1)",
    fill: "#ffd255"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1938",
    "data-name": "Group 1938",
    transform: "translate(7.883 13.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1937",
    "data-name": "Group 1937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1936",
    "data-name": "Group 1936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M430.529,239.18a.654.654,0,0,1,0,.352c-.128.64-.288,1.249-.416,1.889-1.088-.832-1.152-2.529-2.113-3.521.736.32,1.472.672,2.209.992A.7.7,0,0,1,430.529,239.18Z",
    transform: "translate(-428 -237.9)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1978",
    "data-name": "Group 1978",
    transform: "translate(0.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941",
    transform: "translate(0 11.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    "data-name": "Group 1940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1939",
    "data-name": "Group 1939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M421.425,233.218a22.96,22.96,0,0,0-11.684-1.28,4.217,4.217,0,0,0-2.849,1.12c-.768.9-.608,2.177-.384,3.3,1.313,6.274,3.874,12.453,3.617,18.855a68.128,68.128,0,0,1,14.438-.64,37.992,37.992,0,0,1-.384-15.43,5.328,5.328,0,0,0-.768-4A6.674,6.674,0,0,0,421.425,233.218Z",
    transform: "translate(-406.322 -231.72)",
    fill: "#e8e9eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1968",
    "data-name": "Group 1968",
    transform: "translate(3.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951",
    transform: "translate(2.304 7.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M428.35,219.6a14.4,14.4,0,0,1-4.386.1c.352,1.729.544,2.5-.064,4.162,7.715,2.017,5.6,1.569,5.73,1.088C428.542,223.409,428.542,221.489,428.35,219.6Z",
    transform: "translate(-423.9 -219.6)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947",
    transform: "translate(0.512 0.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1946",
    "data-name": "Group 1946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1945",
    "data-name": "Group 1945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M430.686,225.046c-1.056-1.537-1.056-3.489-1.281-5.346a15.715,15.715,0,0,1-3.905.16,37.811,37.811,0,0,0,1.152,4.546C432.35,225.878,430.558,225.494,430.686,225.046Z",
    transform: "translate(-425.5 -219.7)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950",
    transform: "translate(0.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1948",
    "data-name": "Group 1948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M430.218,223.505a19.132,19.132,0,0,1-.576-3.905,16.716,16.716,0,0,1-3.841.192C425.992,222.129,428.041,223.345,430.218,223.505Z",
    transform: "translate(-425.8 -219.6)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1967",
    "data-name": "Group 1967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1954",
    "data-name": "Group 1954",
    transform: "translate(0.779 1.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M423.894,202.971a3.194,3.194,0,0,0-2.113-.128A4.2,4.2,0,0,0,419.54,204a2.639,2.639,0,0,0-.224,2.4,5.587,5.587,0,0,0,3.009,3.361,5.678,5.678,0,0,0,3.713.352.74.74,0,0,0,.608-.8,10.016,10.016,0,0,0-.448-2.625c-.1-.288-.384-.48-.48-.768s.032-.544-.064-.832A3.417,3.417,0,0,0,423.894,202.971Z",
    transform: "translate(-419.136 -202.722)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957",
    transform: "translate(4.865 7.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1956",
    "data-name": "Group 1956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1955",
    "data-name": "Group 1955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2794",
    "data-name": "Path 2794",
    d: "M431.9,223.284a5.484,5.484,0,0,0,2.785.032.74.74,0,0,0,.608-.8c0-.16-.032-.288-.032-.416A3.772,3.772,0,0,1,431.9,223.284Z",
    transform: "translate(-431.9 -222.1)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960",
    transform: "translate(0.747 1.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1959",
    "data-name": "Group 1959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1958",
    "data-name": "Group 1958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2795",
    "data-name": "Path 2795",
    d: "M421.553,205.227a7.171,7.171,0,0,0,2.433-.416,1.715,1.715,0,0,0,1.153-.576,2.77,2.77,0,0,0-1.345-1.216,3.807,3.807,0,0,0-2.721.064,3,3,0,0,0-1.633.992,2.64,2.64,0,0,0-.224,2.4,5.627,5.627,0,0,0,2.3,2.977C421.585,208.044,420.753,206.571,421.553,205.227Z",
    transform: "translate(-419.036 -202.791)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1966",
    "data-name": "Group 1966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1962",
    "data-name": "Group 1962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M424.224,197.2a2.007,2.007,0,0,1-.928.928.952.952,0,0,0,.256-.64,2.645,2.645,0,0,1-1.729.928c-.672.128-1.345.1-1.985.192a2.813,2.813,0,0,0-1.793.8c-.512.544-1.248,1.28-.992,2.081a1.639,1.639,0,0,0-.32,1.312,2.441,2.441,0,0,0,1.088,1.377,8.1,8.1,0,0,1,1.441,1.088,4.492,4.492,0,0,0,.192-1.312,3.417,3.417,0,0,1,.512.448c.128.032.224-.1.256-.224a2.123,2.123,0,0,0-.192-.64c-.16-.288-.288-.224-.448-.48-.032-.1-.1-.16-.128-.256a5.435,5.435,0,0,1,.192-1.633.288.288,0,0,0,.16-.032,10.216,10.216,0,0,0,2.625-.416,2.343,2.343,0,0,0,1.6-1.921c-.128.128-.288.256-.416.384A4.484,4.484,0,0,0,424.224,197.2Z",
    transform: "translate(-416.701 -197.2)",
    fill: "#352f6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1965",
    "data-name": "Group 1965",
    transform: "translate(2.04 6.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1964",
    "data-name": "Group 1964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M424.587,217.994a2.153,2.153,0,0,0-1.184-.7.481.481,0,0,0-.32.448.952.952,0,0,0,.128.576,1.9,1.9,0,0,0,.448.672,1.046,1.046,0,0,0,.48.352.457.457,0,0,0,.544-.192Z",
    transform: "translate(-423.074 -217.285)",
    fill: "#e7a988"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    transform: "translate(12.958 11.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1969",
    "data-name": "Group 1969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M451.7,240.758a5.327,5.327,0,0,0-.768-4,7.186,7.186,0,0,0-2.017-1.921c-.7-.288-1.408-.512-2.113-.736,2.593,7.011,2.017,14.565,2.273,21.96.992.032,1.985.064,2.977.128A39.136,39.136,0,0,1,451.7,240.758Z",
    transform: "translate(-446.8 -234.1)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1974",
    "data-name": "Group 1974",
    transform: "translate(13.214 16.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1973",
    "data-name": "Group 1973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M447.824,266.286c-.032,0-.064,0-.064-.032a.061.061,0,0,1,.032-.1l1.152-.64a.514.514,0,0,0-.352-.16.069.069,0,0,1-.064-.064c0-.032.032-.064.064-.1a.758.758,0,0,0,.544-.7,2.215,2.215,0,0,0-.16-.9l-.032-.1a21.1,21.1,0,0,1-.64-5.666c-.032-1.344-.192-2.881-.352-4.386s-.32-3.041-.352-4.386a.069.069,0,0,1,.064-.064h0a.069.069,0,0,1,.064.064c.032,1.345.192,2.881.352,4.386s.32,3.041.352,4.386a20.631,20.631,0,0,0,.64,5.6l.032.1a2.522,2.522,0,0,1,.16.96.972.972,0,0,1-.416.736.565.565,0,0,1,.288.256.061.061,0,0,1-.032.1l-1.216.672C447.856,266.286,447.856,266.286,447.824,266.286Z",
    transform: "translate(-447.6 -249)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977",
    transform: "translate(12.35 14.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1975",
    "data-name": "Group 1975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M445.444,241.6c-.224.352-.192,1.056-.544,1.248A37.419,37.419,0,0,1,445,256.2c.928.736,1.633,1.056,2.273,1.5.064-1.248.512-1.345.512-1.953,0-.544-.16-1.312-.32-2.561A75.04,75.04,0,0,0,445.444,241.6Z",
    transform: "translate(-444.9 -241.6)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997",
    transform: "translate(0.951 10.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1981",
    "data-name": "Group 1981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M410.972,230.3c-.192,0-.384.576-.576.576a4.97,4.97,0,0,0-.672.128,4.126,4.126,0,0,0-2.849,1.184c-.768.96-.512,2.337-.384,3.553.928,8.483,4.866,11.813,2.849,24.809,1.6-.256,3.681-.736,5.57-1.024a2.359,2.359,0,0,0,1.985-2.433c-.352-6.21-.576-14.95-1.344-20.584C415.23,233.917,413.117,231.58,410.972,230.3Z",
    transform: "translate(-406.344 -230.3)",
    fill: "#7d95c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983",
    transform: "translate(4.211 21.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M419.5,300.349a5.748,5.748,0,0,0,4.13-2.849A41.064,41.064,0,0,1,419.5,300.349Z",
    transform: "translate(-419.5 -297.5)",
    fill: "#c7d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1986",
    "data-name": "Group 1986",
    transform: "translate(0.05 4.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1985",
    "data-name": "Group 1985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1984",
    "data-name": "Group 1984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M406.5,244c.032.352.064.672.128,1.024a33.845,33.845,0,0,0,.9,4.866,17.281,17.281,0,0,0,9.124,8.675c-.128-2.5-.256-5.026-.416-7.395C412.038,249.794,408.229,247.809,406.5,244Z",
    transform: "translate(-406.5 -244)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1993",
    "data-name": "Group 1993",
    transform: "translate(3.014 0.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989",
    transform: "translate(0.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M424.631,259.8a.069.069,0,0,1-.064-.064,80.26,80.26,0,0,0-3.009-18.663V241c0-.032.032-.032.064-.032a4.007,4.007,0,0,0,1.441-.576l-1.376-.192c-.032,0-.032,0-.064-.032,0-.032-.032-.032,0-.064a8.168,8.168,0,0,0-3.073-8.163.068.068,0,1,1,.1-.1,8.311,8.311,0,0,1,3.137,8.227l1.5.192a.069.069,0,0,1,.064.064c0,.032,0,.064-.032.064a4.168,4.168,0,0,1-1.6.672,81.435,81.435,0,0,1,3.009,18.6c0,.1-.032.128-.1.128Z",
    transform: "translate(-418.525 -231.825)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992",
    transform: "translate(0 27.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M415.836,319.93c-.032,0-.064,0-.064-.032a.061.061,0,0,1,.032-.1,7.835,7.835,0,0,1,3.073-.7c.16,0,.32-.032.48-.032a5.357,5.357,0,0,0,3.3-1.216.068.068,0,0,1,.1.1,5.465,5.465,0,0,1-3.393,1.248c-.16,0-.32.032-.48.032a8.244,8.244,0,0,0-3.041.672C415.868,319.93,415.836,319.93,415.836,319.93Z",
    transform: "translate(-415.759 -317.825)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996",
    transform: "translate(4.166 21.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M419.436,299.5c-.032,0-.064,0-.064-.032a.061.061,0,0,1,.032-.1c1.377-.864,2.753-1.761,4.1-2.721.032-.032.064-.032.1.032.032.032.032.064-.032.1-1.312.96-2.689,1.857-4.1,2.721Z",
    transform: "translate(-419.359 -296.634)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000",
    transform: "translate(15.854 12.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M453.6,237.4c2.081,1.761,1.985,3.169,3.041,5.7a24.3,24.3,0,0,1,1.7,5.762,17.924,17.924,0,0,1-.448,4.866c-.576,3.233-.576,6.05-1.5,9.187-.9-1.056-1.825-1.793-1.953-3.169a5.85,5.85,0,0,1,.128-1.665,22.2,22.2,0,0,0,.64-5.794,31.93,31.93,0,0,0-1.313-5.634,45.114,45.114,0,0,1-.992-8.291Z",
    transform: "translate(-452.9 -237.4)",
    fill: "#98a9d8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003",
    transform: "translate(16.11 16.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M453.7,250.1a34.965,34.965,0,0,0,.8,5.186,37.856,37.856,0,0,1,1.312,5.634,25.307,25.307,0,0,1-.64,5.794,5.855,5.855,0,0,0-.128,1.665c.128,1.376,1.056,2.113,1.953,3.169l.192-.672C457.285,263.609,457.541,256.374,453.7,250.1Z",
    transform: "translate(-453.7 -250.1)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030",
    transform: "translate(0 8.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    transform: "translate(0 3.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M416.636,245.984c.256-1.569-.256-2.017-1.249-3.3s-1.889-1.184-3.169-2.145c-1.633-1.216-3.265-4.194-4.9-5.41a3.852,3.852,0,0,0-1.28-.7,2.282,2.282,0,0,0-2.337,1.28,4.463,4.463,0,0,0-.192,2.817,11.516,11.516,0,0,0,3.233,5.634A25.471,25.471,0,0,0,412.09,248c1.056.608,2.369,1.184,3.489.7C416.444,248.352,416.476,246.912,416.636,245.984Z",
    transform: "translate(-403.375 -234.393)",
    fill: "#98a9d8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "translate(0.316 0.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M404.886,240.52a4.591,4.591,0,0,1,1.344-4.162c-.352-.192-.768.064-1.024.352a3.1,3.1,0,0,0-.832,1.857A3,3,0,0,0,404.886,240.52Z",
    transform: "translate(-404.362 -236.292)",
    fill: "#c7d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(2.597 1.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M412.068,238.138a.325.325,0,0,0-.224-.448.317.317,0,0,0-.352.256.294.294,0,0,0,.288.32A.259.259,0,0,0,412.068,238.138Z",
    transform: "translate(-411.487 -237.685)",
    fill: "#c7d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(7.901 6.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M428.71,253.9a5.357,5.357,0,0,0-.544,3.649,5.123,5.123,0,0,0,2.017,3.105,8.472,8.472,0,0,1-.1-6.018C429.606,254.412,429.158,254.156,428.71,253.9Z",
    transform: "translate(-428.055 -253.9)",
    fill: "#352f6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029",
    transform: "translate(8.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    transform: "translate(2.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M438.6,223.5a3.033,3.033,0,0,1,.928-.224,3.444,3.444,0,0,1,1.28,0,7.577,7.577,0,0,1,1.152.544.3.3,0,0,1,.192.384c-.064.192-.128.352-.192.576-.032.128,0,.352-.128.384a.3.3,0,0,1-.32-.192.91.91,0,0,1,0-.416,3.25,3.25,0,0,1-1.024.7,3.6,3.6,0,0,0-.032,1.313c-.672-.064-1.377-.16-2.049-.288a.611.611,0,0,1-.448-.224.928.928,0,0,1-.064-.288c0-.512.128-.928.128-1.473C438.188,224.008,438.284,223.655,438.6,223.5Z",
    transform: "translate(-437.9 -223.211)",
    fill: "#e7a988"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(2.144 1.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M438.064,228.8a6.211,6.211,0,0,0-.064.768.475.475,0,0,0,.064.288.56.56,0,0,0,.448.224c.672.128,1.344.224,2.049.288a2.809,2.809,0,0,1-.032-.9A10.8,10.8,0,0,1,438.064,228.8Z",
    transform: "translate(-438 -228.8)",
    fill: "#d88568"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    transform: "translate(0 2.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M434.214,246.546a2.111,2.111,0,0,0,1.377-1.376,6.917,6.917,0,0,0,.288-1.985c.128-3.777.416-8.1.544-11.876-.832-.256-2.785-.352-3.585-.608-.448,4.226-1.985,8.611-1.409,12.837a4.352,4.352,0,0,0,.768,2.177A2.184,2.184,0,0,0,434.214,246.546Z",
    transform: "translate(-431.301 -230.7)",
    fill: "#98a9d8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    transform: "translate(0.055 4.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2816",
    "data-name": "Path 2816",
    d: "M432.923,238.5a44.988,44.988,0,0,0-1.28,5.826,15.346,15.346,0,0,0,.256,5.922A42.632,42.632,0,0,1,432.923,238.5Z",
    transform: "translate(-431.475 -238.5)",
    fill: "#c7d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028",
    transform: "translate(1.363 3.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M439.253,234.74a10.95,10.95,0,0,1-3.649-.64.072.072,0,0,1,.064-.128,10.582,10.582,0,0,0,3.585.64h.064a.064.064,0,0,1,0,.128Z",
    transform: "translate(-435.559 -233.959)",
    fill: "#352f6c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043",
    transform: "translate(13.869 11.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M451.95,261.462c.32.064.672.1.96.128-1.152-5.666-2.241-14.726-1.28-20.424.224-1.345.256-3.265-.544-4.354A8.3,8.3,0,0,0,449,234.668a21.6,21.6,0,0,0-2.3-.768,8.434,8.434,0,0,1,1.409,2.977c1.12,6.146,1.12,15.814,1.857,22.536A2.376,2.376,0,0,0,451.95,261.462Z",
    transform: "translate(-446.7 -233.9)",
    fill: "#7d95c9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(0.819 0.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M452.569,261.614a.069.069,0,0,1-.064-.064,112.562,112.562,0,0,1-.288-17.351l-1.024.16a.072.072,0,1,1-.064-.128l1.249-.864a27.389,27.389,0,0,0-3.105-8.1.072.072,0,1,1,.128-.064,27.079,27.079,0,0,1,3.105,8.2c0,.032,0,.064-.032.064l-1.024.7.8-.128c.032,0,.032,0,.064.032.032,0,.032.032.032.064a113.471,113.471,0,0,0,.288,17.415c.032,0,0,.032-.064.064Z",
    transform: "translate(-449.259 -235.159)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(3.937 26.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M461.017,317.868a3.412,3.412,0,0,1-1.985-.64.072.072,0,1,1,.064-.128,3.261,3.261,0,0,0,2.017.608.064.064,0,0,1,0,.128A.118.118,0,0,1,461.017,317.868Z",
    transform: "translate(-459 -317.1)",
    fill: "#352f6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042",
    transform: "translate(4.33 21.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M460.953,300.321c-.032,0-.032,0-.032-.032l-.672-.544a.068.068,0,0,1,.1-.1l.672.544a.06.06,0,0,1,0,.1A.112.112,0,0,0,460.953,300.321Z",
    transform: "translate(-460.225 -299.625)",
    fill: "#352f6c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046",
    transform: "translate(6.56 6.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M423.911,218.4a1.493,1.493,0,0,1,.64.384c.032.032.032.064.064.1,0,.064-.064.128-.064.192a.243.243,0,0,0,.128.32c.064.032.16.032.16.1,0,.032-.032.064-.064.1a.241.241,0,0,0-.064.32,1.681,1.681,0,0,1-.352-.32.387.387,0,0,1-.032-.448c0-.032.032-.032,0-.064h-.032a.386.386,0,0,1-.32-.224A.4.4,0,0,1,423.911,218.4Z",
    transform: "translate(-423.869 -218.4)",
    fill: "#d88568"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessBanner);
export default __webpack_public_path__ + "static/media/business_banner.d75639c0be76eac612091408927deb81.svg";
export { ForwardRef as ReactComponent };